$("body").on("click", ".wizzy__featuredview__cart__dj89c", () => {
  window.location.href = "/cart";
});
const availableSizeStrings = [
  "0-3 M",
  "3-6 M",
  "0-6 M",
  "6-9 M",
  "9-12 M",
  "6-12 M",
  "12-18 M",
  "18-24 M",
  "1-2 Y",
  "2 Y",
  "2-3 Y",
  "3-4 Y",
  "4-5 Y",
  "5-6 Y",
  "6-7 Y",
  "7-8 Y",
  "8-9 Y",
  "9-10 Y",
  "10-11 Y",
  "11-12 Y",
  "12-13 Y",
  "13-14 Y",
  "Extra Small",
  "Small",
  "Medium",
  "Large",
  "Extra Large",
  "Single",
  "Double",
  "King",
  "XXS",
  "XS",
  "S",
  "M",
  "S/M",
  "L",
  "XL",
  "L/XL",
  "XXL",
  "3XL",
  "EURO-12",
  "EURO-14",
  "EURO-28",
  "EURO-29",
  "EURO-30",
  "EURO-33",
  "EURO-35",
  "EURO-40",
  "EURO-41",
  "EURO-42",
  "EURO-43",
  "EURO-44",
  "EURO-45",
  "10 ML",
  "25 ML",
  "25 ml",
  "30 ML",
  "50 ML",
  "100 ML",
  "26",
  "28",
  "30",
  "32",
  "34",
  "36",
  "38",
  "40",
  "42",
  "44",
  "46",
  "32B",
  "34B",
  "36B",
  "38B",
  "32C",
  "34C",
  "38C",
  "36C",
  "32D",
  "34D",
  "36D",
  "38D",
  "32DD",
  "34DD",
  "36DD",
  "38DD",
  "32E",
  "34E",
  "36E",
  "38E",
  "Free Size",
];

let collectionFilter = [
  {
    label: "Collection",
    key: "product_value_tags_collection_new",
    position: "left",
    order: 1,
  },
  {
    label: "Type of Product",
    key: "product_value_tags_type_of_product_new",
    position: "left",
    order: 2,
  },
  {
    label: "Size",
    key: "sizes",
    position: "left",
    order: 3,
  },
  {
    label: "Brand",
    key: "brands",
    position: "left",
    order: 4,
  },
  {
    label: "Colour",
    key: "product_value_tags_colour_new",
    position: "left",
    order: 5,
  },
  {
    label: "Color Family",
    key: "product_value_tags_color_family_new",
    position: "left",
    order: 6,
  },
  {
    label: "Gender",
    key: "genders",
    position: "left",
    order: 7,
  },
  {
    label: "Price",
    key: "sellingPrice",
    position: "left",
    order: 8,
  },
  {
    label: "Fabric",
    key: "product_value_tags_fabric_new",
    position: "left",
    order: 9,
  },
  {
    label: "Fit",
    key: "product_value_tags_fit_new",
    position: "left",
    order: 10,
  },
  {
    label: "Craft",
    key: "product_value_tags_craft_new",
    position: "left",
    order: 11,
  },
  {
    label: "Pattern",
    key: "product_value_tags_pattern_new",
    position: "left",
    order: 12,
  },
  {
    label: "Sleeves",
    key: "product_value_tags_sleeves_new",
    position: "left",
    order: 13,
  },
  {
    label: "Sleeve Length",
    key: "product_value_tags_sleeve_length_new",
    position: "left",
    order: 14,
  },
  {
    label: "Occasion",
    key: "product_value_tags_occasion_new",
    position: "left",
    order: 15,
  },
  {
    label: "Collar Type",
    key: "product_value_tags_collar_type_new",
    position: "left",
    order: 16,
  },
  {
    label: "Length",
    key: "product_value_tags_length_new",
    position: "left",
    order: 17,
  },
  {
    label: "Fragrance",
    key: "product_value_tags_fragrance_new",
    position: "left",
    order: 18,
  },
  {
    label: "Washcare",
    key: "product_value_tags_washcare_new",
    position: "left",
    order: 19,
  },
  {
    label: "Fabric Weave",
    key: "product_value_tags_fabric_weave_new",
    position: "left",
    order: 20,
  },
  {
    label: "Cookware Type",
    key: "product_value_tags_cookware_type_new",
    position: "left",
    order: 21,
  },
  {
    label: "Bath Linen Type",
    key: "product_value_tags_bath_linen_type_new",
    position: "left",
    order: 22,
  },
  {
    label: "Bath Mat Type",
    key: "product_value_tags_bath_mat_type_new",
    position: "left",
    order: 23,
  },
  {
    label: "Category",
    key: "product_value_tags_category_new",
    position: "left",
    order: 24,
  },
  {
    label: "Formulation",
    key: "product_value_tags_formulation_new",
    position: "left",
    order: 25,
  },
  {
    label: "Skin Type",
    key: "product_value_tags_skin_type_new",
    position: "left",
    order: 26,
  },
  {
    label: "Benefit",
    key: "product_value_tags_benefit_new",
    position: "left",
    order: 27,
  },
  {
    label: "Finish",
    key: "product_value_tags_finish_new",
    position: "left",
    order: 28,
  },
  {
    label: "Coverage",
    key: "product_value_tags_coverage_new",
    position: "left",
    order: 29,
  },
  {
    label: "Dress Style",
    key: "product_value_tags_dress_style_new",
    position: "left",
    order: 30,
  },
  {
    label: "Fragrance Family",
    key: "product_value_tags_fragrance_family_new",
    position: "left",
    order: 31,
  },
  {
    label: "Time",
    key: "product_value_tags_time_new",
    position: "left",
    order: 32,
  },
  {
    label: "Brief Type",
    key: "product_value_tags_brief_type_new",
    position: "left",
    order: 33,
  },
  {
    label: "Bra Type",
    key: "product_value_tags_bra_type_new",
    position: "left",
    order: 34,
  },
  {
    label: "Padding",
    key: "product_value_tags_padding_new",
    position: "left",
    order: 35,
  },
  {
    label: "Wiring",
    key: "product_value_tags_wiring_new",
    position: "left",
    order: 36,
  },
  {
    label: "Waist Rise",
    key: "product_value_tags_waist_rise_new",
    position: "left",
    order: 37,
  },
  {
    label: "Neckline",
    key: "product_value_tags_neckline_new",
    position: "left",
    order: 38,
  },
  {
    label: "Material",
    key: "product_value_tags_fabric_new",
    position: "left",
    order: 39,
  },
];

function getFilterArray(keys) {
  console.log(keys);
  let data = [];
  keys.forEach((key, index) => {
    collectionFilter.forEach((filter) => {
      // console.log(filter.key,key);
      if (filter.label == key) {
        data.push({ ...filter, order: index });
      }
    });
  });
  return data;
}

//waist raise
//neckline
//neckline,waist raise
//
//Waist raise

const collectionFilterMap = new Map([
  [
    "view-all-western-wear-for-women",
    [
      "Collection",
      "Type of Product",
      "Dress Style",
      "Brand",
      "Occasion",
      "Size",
      "Colour",
      "Fabric",
      "Fit",
      "Pattern",
      "Waist Rise",
      "Sleeves",
      "Length",
      "Price",
    ],
  ],
  [
    "view-all-ethnic-wear-for-women",
    [
      "Collection",
      "Type of Product",
      "Brand",
      "Occasion",
      "Size",
      "Colour",
      "Fabric",
      "Fit",
      "Sleeves",
      "Neckline",
      "Length",
      "Price",
    ],
  ],
  [
    "view-all-plus-size-for-women",
    [
      "Collection",
      "Type of Product",
      "Dress Style",
      "Brand",
      "Occasion",
      "Size",
      "Colour",
      "Fabric",
      "Fit",
      "Pattern",
      "Waist Rise",
      "Sleeves",
      "Length",
      "Neckline",
      "Price",
    ],
  ],
  [
    "footwear-for-women",
    ["Type of Product", "Brand", "Size", "Colour", "Occasion", "Price"],
  ],
  [
    "co-ord-set",
    [
      "Collection",
      "Type of Product",
      "Brand",
      "Craft",
      "Occasion",
      "Size",
      "Colour",
      "Fabric",
      "Fit",
      "Sleeves",
      "Length",
      "Price",
    ],
  ],
  ["gift-shop", ["Category", "Colour", "Size", "Brand", "Gender", "Price"]],
  [
    "view-all-lingerie",
    [
      "Type of Product",
      "Size",
      "Brand",
      "Colour",
      "Pattern",
      "Fabric",
      "Fit",
      "Bra Type",
      "Brief Type",
      "Wiring",
      "Coverage",
      "Padding",
      "Price",
    ],
  ],
  [
    "lingerie-swimwear",
    [
      "Brand",
      "Size",
      "Type of Product",
      "Colour",
      "Pattern",
      "Fabric",
      "Neckline",
      "Fit",
      "Sleeve Length",
      "Price",
    ],
  ],
  [
    "loungewear-and-sleepwear",
    [
      "Brand",
      "Type of Product",
      "Size",
      "Colour",
      "Fit",
      "Pattern",
      "Fabric",
      "Neckline",
      "Price",
    ],
  ],
  [
    "view-all-menswear",
    [
      "Type of Product",
      "Brand",
      "Pattern",
      "Size",
      "Colour",
      "Fabric",
      "Fit",
      "Sleeve Length",
      "Collar Type",
      "Waist Rise",
      "Price",
      "Occasion",
    ],
  ],
  [
    "shoes-for-men",
    ["Type of Product", "Brand", "Size", "Colour", "Occasion", "Price"],
  ],
  [
    "view-all-kids",
    [
      "Type of Product",
      "Brand",
      "Size",
      "Fit",
      "Colour",
      "Pattern",
      "Fabric",
      "Collection",
      "Price",
    ],
  ],
  [
    "perfumes-and-fragrances",
    ["Gender", "Time", "Size", "Type of Product", "Fragrance Family", "Price"],
  ],
  [
    "skincare-view-all",
    ["Formulation", "Type of Product", "Skin Type", "Gender", "Price"],
  ],
  ["view-all-accessories", ["Collection", "Price"]],
  [
    "makeup",
    [
      "Colour",
      "Category",
      "Formulation",
      "Skin Type",
      "Benefit",
      "Finish",
      "Size",
      "Coverage",
      "Type of Product",
      "Price",
    ],
  ],
  [
    "living",
    ["Size", "Pattern", "Material", "Colour", "Brand", "Type of Product"],
  ],
  [
    "kitchen",
    ["Size", "Colour", "Pattern", "Material", "Brand", "Type of Product"],
  ],
  [
    "bed",
    ["Size", "Colour", "Pattern", "Material", "Brand", "Type of Product"],
  ],
  [
    "bath",
    ["Size", "Colour", "Pattern", "Material", "Brand", "Type of Product"],
  ],
]);

const childParentMap = new Map([
  ["view-all-western-wear-for-women", "view-all-western-wear-for-women"],
  ["new-in-western-wear-for-women", "view-all-western-wear-for-women"],
  ["dresses-jumpsuits", "view-all-western-wear-for-women"],
  ["blazer-and-jacket", "view-all-western-wear-for-women"],
  ["shirts-tops", "view-all-western-wear-for-women"],
  ["t-shirts-for-women", "view-all-western-wear-for-women"],
  ["jeans-western-wear-for-women", "view-all-western-wear-for-women"],
  ["trousers-joggers", "view-all-western-wear-for-women"],
  ["trending-now-western-wear-for-women", "view-all-western-wear-for-women"],
  ["skirts-shorts", "view-all-western-wear-for-women"],
  ["winterwear-for-women", "view-all-western-wear-for-women"],

  ["view-all-ethnic-wear-for-women", "view-all-ethnic-wear-for-women"],
  ["new-in-ethnic-wear-for-women", "view-all-ethnic-wear-for-women"],
  ["kurtas-for-women", "view-all-ethnic-wear-for-women"],
  ["ethnic-suits-for-women", "view-all-ethnic-wear-for-women"],
  ["kurtis-tunics-for-women", "view-all-ethnic-wear-for-women"],
  ["ethnic-dresses-for-women", "view-all-ethnic-wear-for-women"],
  ["ethnic-tops-for-women", "view-all-ethnic-wear-for-women"],
  ["palazzos-skirts-ethnic-wear-for-women", "view-all-ethnic-wear-for-women"],
  ["salwars-pants-ethnic-wear-for-women", "view-all-ethnic-wear-for-women"],
  ["dupattas-stoles-ethnic-wear-for-women", "view-all-ethnic-wear-for-women"],
  ["ethnic-co-ord-sets-for-women", "view-all-ethnic-wear-for-women"],
  ["trending-now-ethnic-wear-for-women", "view-all-ethnic-wear-for-women"],

  ["view-all-plus-size-for-women", "view-all-plus-size-for-women"],
  ["new-in-for-plus-size-women", "view-all-plus-size-for-women"],
  ["dresses-for-plus-size-women", "view-all-plus-size-for-women"],
  ["shirts-tops-1", "view-all-plus-size-for-women"],
  ["jackets-for-plus-size-women", "view-all-plus-size-for-women"],
  ["t-shirts-for-plus-size-women", "view-all-plus-size-for-women"],
  ["jeans-for-plus-size-women", "view-all-plus-size-for-women"],
  ["trousers-for-plus-size-women", "view-all-plus-size-for-women"],
  ["kurtas-for-plus-size-women", "view-all-plus-size-for-women"],
  ["kurtis-for-plus-size-women", "view-all-plus-size-for-women"],
  ["trending-now-for-plus-size-women", "view-all-plus-size-for-women"],
  ["winterwear-for-plus-size-women", "view-all-plus-size-for-women"],
  ["ethnic-wear-plus-size-palazzos-and-pants", "view-all-plus-size-for-women"],

  ["footwear-for-women", "footwear-for-women"],
  ["new-in-womens-footwear", "footwear-for-women"],
  ["flat-sandals-for-women", "footwear-for-women"],
  ["comfort-sandals-for-women", "footwear-for-women"],
  ["flat-shoes-for-women", "footwear-for-women"],
  ["heeled-sandals-for-women", "footwear-for-women"],
  ["woman-heeled-shoes", "footwear-for-women"],
  ["sneakers-for-women", "footwear-for-women"],
  ["flip-flops-for-women", "footwear-for-women"],
  ["woman-boots", "footwear-for-women"],
  ["bags", "footwear-for-women"],
  ["accessories", "footwear-for-women"],
  ["woman-beauty", "footwear-for-women"],
  ["view-all-lingerie", "view-all-lingerie"],
  ["lingerie-swimwear", "lingerie-swimwear"],
  ["loungewear-and-sleepwear", "loungewear-and-sleepwear"],

  ["co-ord-set", "co-ord-set"],

  ["gift-shop", "gift-shop"],

  ["view-all-menswear", "view-all-menswear"],
  ["men-new-in", "view-all-menswear"],
  ["winterwear-for-men", "view-all-menswear"],
  ["casual-shirts-for-men", "view-all-menswear"],
  ["formal-shirts-for-men", "view-all-menswear"],
  ["polo-t-shirts-for-men", "view-all-menswear"],
  ["t-shirts-for-men", "view-all-menswear"],
  ["sweatshirts-for-men", "view-all-menswear"],
  ["men-jeans", "view-all-menswear"],
  ["casual-trousers-chinos-for-men", "view-all-menswear"],
  ["blazers-and-jackets-for-men", "view-all-menswear"],
  ["formal-trousers-for-men", "view-all-menswear"],
  ["joggers-shorts-for-men", "view-all-menswear"],
  ["loungewear-sleepwear-for-men", "view-all-menswear"],
  ["mens-underwear", "view-all-menswear"],

  ["shoes-for-men", "shoes-for-men"],
  ["new-in-mens-footwear", "shoes-for-men"],
  ["casual-shoes-for-men", "shoes-for-men"],
  ["formal-shoes-for-men", "shoes-for-men"],
  ["sneakers-for-men-online", "shoes-for-men"],
  ["flip-flop-slides-clog-for-men", "shoes-for-men"],
  ["boots-for-men", "shoes-for-men"],
  ["gifts-for-him", "shoes-for-men"],

  ["new-in-kids", "view-all-kids"],
  ["view-all-kids", "view-all-kids"],
  ["trending-now-kidswear", "view-all-kids"],
  ["kids-girl-dresses-jumpsuits", "view-all-kids"],
  ["tops-jackets", "view-all-kids"],
  ["skirts-shorts-1", "view-all-kids"],
  ["denim-trousers", "view-all-kids"],
  ["ethnic-wear-for-kids-girl", "view-all-kids"],
  ["kids-girl-underwear", "view-all-kids"],
  ["girls-footwear", "view-all-kids"],
  ["shirts-t-shirt", "view-all-kids"],
  ["kids-boy-sweatshirts", "view-all-kids"],
  ["denim-trousers-1", "view-all-kids"],
  ["joggers-shorts", "view-all-kids"],
  ["kids-boys-underwear", "view-all-kids"],
  ["boys-footwear", "view-all-kids"],
  ["baby-girl-dresses-jumpsuits", "view-all-kids"],
  ["baby-girl-tops-t-shirts", "view-all-kids"],
  ["baby-girl-sweatshirts-jackets-for-infant-toddler-girls", "view-all-kids"],
  ["baby-girl-leggings-joggers", "view-all-kids"],
  ["baby-girl-rompers-bodysuits", "view-all-kids"],
  ["baby-girl-accessories", "view-all-kids"],
  ["baby-girls-footwear", "view-all-kids"],
  ["shirts-t-shirts", "view-all-kids"],
  ["jackets", "view-all-kids"],
  ["baby-boy-jeans", "view-all-kids"],
  ["joggers-shorts-1", "view-all-kids"],
  ["baby-boy-rompers-bodysuits", "view-all-kids"],
  ["baby-boy-accessories", "view-all-kids"],
  ["baby-boys-footwear", "view-all-kids"],

  ["perfumes-and-fragrances", "perfumes-and-fragrances"],
  ["fragrance-view-all", "perfumes-and-fragrances"],
  ["perfumes-and-fragrances-for-men", "perfumes-and-fragrances"],
  ["perfumes-and-fragrances-for-women", "perfumes-and-fragrances"],
  ["unisex-perfume", "perfumes-and-fragrances"],

  ["skincare-view-all", "skincare-view-all"],
  ["skincare-for-all", "skincare-view-all"],
  ["bath-and-body-care", "skincare-view-all"],

  ["view-all-accessories", "view-all-accessories"],

  ["makeup", "makeup"],
  ["face-cheek", "makeup"],
  ["eye", "makeup"],
  ["makeup-lips", "makeup"],
  ["studiowest-makeup-nails", "makeup"],
  ["studiowest-makeup-makeup-removers", "makeup"],

  ["living", "living"],
  ["living-cushion", "living"],
  ["living-decor", "living"],
  ["living-candles-stands", "living"],
  ["home-fragrance", "living"],
  ["living-flowers-planters", "living"],
  ["home-living-plants-planters", "living"],
  ["living-lights-lanterns", "living"],

  ["kitchen", "kitchen"],
  ["bottles", "kitchen"],
  ["home-kitchen-tea-and-coffee", "kitchen"],
  ["home-kitchen-serve-ware", "kitchen"],
  ["home-kitchen-kitchenware", "kitchen"],
  ["home-kitchen-table-linen", "kitchen"],

  ["bed", "bed"],
  ["home-bed-bed-sheets-bed-covers", "bed"],
  ["home-bed-pillow-cases-fillers", "bed"],
  ["duvet-covers-and-comforters", "bed"],

  ["bath", "bath"],
  ["bath-towels-mats", "bath"],
  ["bath-bath-accessories", "bath"],
]);

let serachFacetList = [
  {
    label: "Categories",
    key: "product_product_type",
    position: "left",
    order: 0,
  },
  { label: "Size", key: "sizes", position: "left", order: 1 },
  { label: "Brand", key: "brands", position: "left", order: 2 },
  { label: "Color", key: "colors", position: "left", order: 3 },
  { label: "Gender", key: "genders", position: "left", order: 4 },
  { label: "Price", key: "sellingPrice", position: "left", order: 5 },
  {
    label: "Design",
    key: "product_value_tags_design",
    position: "left",
    order: 6,
  },
  {
    label: "Fabric/Material",
    key: "product_value_tags_fabric_material",
    position: "left",
    order: 7,
  },
  {
    label: "Occasion",
    key: "product_value_tags_occasion",
    position: "left",
    order: 8,
  },
  {
    label: "Fit",
    key: "product_value_tags_fit",
    position: "left",
    order: 9,
  },
  {
    label: "Neck Design",
    key: "product_value_tags_neck_design",
    position: "left",
    order: 10,
  },
  {
    label: "Closure",
    key: "product_value_tags_closure",
    position: "left",
    order: 11,
  },
  {
    label: "Sleeve Length",
    key: "product_value_tags_sleeve_length",
    position: "left",
    order: 12,
  },
  {
    label: "Sleeve Type",
    key: "product_value_tags_sleeve_type",
    position: "left",
    order: 13,
  },
  {
    label: "Dress Length",
    key: "product_value_tags_length",
    position: "left",
    order: 14,
  },
];
const addSorting = (filter) => {
  let newSort = [];
  newSort.push(
    {
      field: "gender",
      order: "desc",
    },
    {
      field: "product_value_tags_is_new_ruled_based_bt:float",
      order: "desc",
    },
    {
      field: "relevance",
      order: "asc",
    }
  ),
    // filter.sort.forEach(x=>{
    //   newSort.push(x)
    // }
    // ),

    (filter.sort = newSort);
};
const addCollectionSorting = (filter) => {
  let newSort = [];
  newSort.push(
    {
      field: "relevance",
      order: "asc",
    },

    {
      field: "createdAt",
      order: "desc",
    },
    {
      field: "product_value_tags_gender",
      order: "desc",
    }
  );
  newSort.push(filter.sort[filter.length - 1]);
  // filter.sort.forEach(x=>{
  //   newSort.push(x)
  // }
  // ),

  filter.sort = newSort;
};
const changeTemplate = (div) => {
  const oldDiv = document.getElementById(div);
  const newDiv = document.getElementById(div + "-new").text;
  oldDiv.text = newDiv;
};

// Change for internation market - 31-01-2026
const bulkQueryRedirect = function (q) {
  const redirectByQuery = new Map([
    ["ss24", "https://global.westside.com/collections/new-in-view-all"],
    ["ss24janwk", "https://global.westside.com/collections/new-in-view-all"],
    ["ss23", "https://global.westside.com/collections/new-in-view-all"],
    ["ss24j", "https://global.westside.com/collections/new-in-view-all"],
    ["ss24ja", "https://global.westside.com/collections/new-in-view-all"],
    ["ss24janw", "https://global.westside.com/collections/new-in-view-all"],
    ["furniture", "https://global.westside.com/pages/furniture-catalogue-new"],
    ["membership", "https://global.westside.com/pages/membership"],
    ["holi", "https://global.westside.com/collections/holi-collection"],
    [
      "clothes for holi",
      "https://global.westside.com/collections/holi-collection",
    ],
    ["holi apparel", "https://global.westside.com/collections/holi-collection"],
    ["holi clothes", "https://global.westside.com/collections/holi-collection"],
    ["holi collection", "https://global.westside.com/collections/holi-collection"],
    ["holi dress", "https://global.westside.com/collections/holi-collection"],
    ["holi dresses", "https://global.westside.com/collections/holi-collection"],
    ["holi t-shirt", "https://global.westside.com/collections/holi-collection"],
    ["holi tshirts", "https://global.westside.com/collections/holi-collection"],
    ["holi t-shirts", "https://global.westside.com/collections/holi-collection"],
    [
      "white clothes for holi",
      "https://global.westside.com/collections/holi-collection",
    ],
    [
      "white dress for holi",
      "https://global.westside.com/collections/holi-collection",
    ],
    ["white for holi", "https://global.westside.com/collections/holi-collection"],
    [
      "white kurta for holi",
      "https://global.westside.com/collections/holi-collection",
    ],
    [
      "white shirt for holi",
      "https://global.westside.com/collections/holi-collection",
    ],
    [
      "white shorts for holi",
      "https://global.westside.com/collections/holi-collection",
    ],
    [
      "white top for holi",
      "https://global.westside.com/collections/holi-collection",
    ],
    ["swimwear", "https://global.westside.com/collections/lingerie-swimwear"],
    ["women size chart", "https://global.westside.com/collections/woman"],
    ["women size", "https://global.westside.com/collections/woman"],
    [
      "men size chart",
      "https://global.westside.com/collections/view-all-menswear",
    ],
    ["men size", "https://global.westside.com/collections/view-all-menswear"],
    ["bra size chart", "https://global.westside.com/collections/bra-for-women"],
    ["bra size", "https://global.westside.com/collections/bra-for-women"],
    [
      "panties size chart",
      "https://global.westside.com/collections/panties-for-women",
    ],
    ["panties size", "https://global.westside.com/collections/panties-for-women"],
    ["kids size chart", "https://global.westside.com/collections/view-all-kids"],
    ["kids size", "https://global.westside.com/collections/view-all-kids"],
    ["return policy", "https://global.westside.com/pages/return-policy"],
    ["customer policy", "https://global.westside.com/pages/return-policy"],
    ["customer return", "https://global.westside.com/pages/return-policy"],
    ["return", "https://global.westside.com/pages/return-policy"],
    ["request for return", "https://global.westside.com/pages/return-policy"],
    ["returns", "https://global.westside.com/pages/return-policy"],
    ["product return", "https://global.westside.com/pages/return-policy"],
    ["return product", "https://global.westside.com/pages/return-policy"],
    ["birthday", "https://global.westside.com/collections/gifts-for-her"],
    ["birthday dr", "https://global.westside.com/collections/gifts-for-her"],
    ["birthday outf", "https://global.westside.com/collections/gifts-for-her"],
    ["birthday outfits", "https://global.westside.com/collections/gifts-for-her"],
    ["birthday o", "https://global.westside.com/collections/gifts-for-her"],
    ["birthday outfit", "https://global.westside.com/collections/gifts-for-her"],
    ["birthday de", "https://global.westside.com/collections/gifts-for-her"],
    [
      "birthday outfits for",
      "https://global.westside.com/collections/gifts-for-her",
    ],
    ["birthday t", "https://global.westside.com/collections/gifts-for-her"],
    ["birthday to", "https://global.westside.com/collections/gifts-for-her"],
    ["birthday ou", "https://global.westside.com/collections/gifts-for-her"],
    ["birthday outfi", "https://global.westside.com/collections/gifts-for-her"],
    ["birthday party", "https://global.westside.com/collections/gifts-for-her"],
    [
      "birthday outfits f",
      "https://global.westside.com/collections/gifts-for-her",
    ],
    ["birthday f", "https://global.westside.com/collections/gifts-for-her"],
    [
      "birthday outfit for",
      "https://global.westside.com/collections/gifts-for-her",
    ],
    [
      "birthday outfits for a",
      "https://global.westside.com/collections/gifts-for-her",
    ],
    [
      "birthday outfit gi",
      "https://global.westside.com/collections/gifts-for-her",
    ],
    ["birthday mo", "https://global.westside.com/collections/gifts-for-her"],
    ["birthday offer", "https://global.westside.com/collections/gifts-for-her"],
    [
      "dressewomen for birthday",
      "https://global.westside.com/collections/gifts-for-her",
    ],
    ["black birthday dr", "https://global.westside.com/collections/gifts-for-her"],
    [
      "dresseswomen for birthday",
      "https://global.westside.com/collections/gifts-for-her",
    ],
    ["black birthday d", "https://global.westside.com/collections/gifts-for-her"],
    ["birthday month o", "https://global.westside.com/collections/gifts-for-her"],
    [
      "dreswomen for birthday",
      "https://global.westside.com/collections/gifts-for-her",
    ],
    ["black birthda", "https://global.westside.com/collections/gifts-for-her"],
    [
      "dresswomen for birthday",
      "https://global.westside.com/collections/gifts-for-her",
    ],
    [
      "drewomen for birthday",
      "https://global.westside.com/collections/gifts-for-her",
    ],
    ["birthdayd", "https://global.westside.com/collections/gifts-for-her"],
    ["birthdaydr", "https://global.westside.com/collections/gifts-for-her"],
    ["birthday p", "https://global.westside.com/collections/gifts-for-her"],
    ["birthdaydre", "https://global.westside.com/collections/gifts-for-her"],
    ["happy birthday g", "https://global.westside.com/collections/gifts-for-her"],
    ["birthday pa", "https://global.westside.com/collections/gifts-for-her"],
    ["birthdaydres", "https://global.westside.com/collections/gifts-for-her"],
    [
      "happy birthday gift",
      "https://global.westside.com/collections/gifts-for-her",
    ],
    ["birth day", "https://global.westside.com/collections/gifts-for-her"],
    ["birthdaydress", "https://global.westside.com/collections/gifts-for-her"],
    ["birthday outfit f", "https://global.westside.com/collections/gifts-for-her"],
    ["birthday", "https://global.westside.com/pages/membership"],
    ["birth", "https://global.westside.com/pages/membership"],
    ["birthda", "https://global.westside.com/pages/membership"],
    ["birthday d", "https://global.westside.com/pages/membership"],
    ["black birthday", "https://global.westside.com/pages/membership"],
    ["birthday month", "https://global.westside.com/pages/membership"],
    ["birthday month of", "https://global.westside.com/pages/membership"],
    ["birthday month offer", "https://global.westside.com/pages/membership"],
    ["happy birthday", "https://global.westside.com/pages/membership"],
    ["birtj", "https://global.westside.com/pages/membership"],
    ["happybirthday gift", "https://global.westside.com/pages/membership"],
    ["birthday party w", "https://global.westside.com/pages/membership"],
    ["birthday outfits fo", "https://global.westside.com/pages/membership"],
    ["birthday outfit fo", "https://global.westside.com/pages/membership"],
    ["birthday gift", "https://global.westside.com/pages/membership"],
    ["birthday party we", "https://global.westside.com/pages/membership"],
    ["birthday fr", "https://global.westside.com/pages/membership"],
    ["birthday outfit for w", "https://global.westside.com/pages/membership"],
    ["birthday frock", "https://global.westside.com/pages/membership"],
    ["birthday discount", "https://global.westside.com/pages/membership"],
    ["birthday outfits for a t", "https://global.westside.com/pages/membership"],
    ["birthday br", "https://global.westside.com/pages/membership"],
    ["birthday outfit for wo", "https://global.westside.com/pages/membership"],
    ["birthday outfit g", "https://global.westside.com/pages/membership"],
    ["birthday m", "https://global.westside.com/pages/membership"],
    ["birthday outfits for a te", "https://global.westside.com/pages/membership"],
    ["discount", "https://global.westside.com/pages/membership"],
    [
      "father's day",
      "https://global.westside.com/collections/fathers-day-special",
    ],
    ["fathers day", "https://global.westside.com/collections/fathers-day-special"],
    ["father", "https://global.westside.com/collections/fathers-day-special"],
    ["father's", "https://global.westside.com/collections/fathers-day-special"],
    [
      "gift for daddy",
      "https://global.westside.com/collections/fathers-day-special",
    ],
    ["gift for men", "https://global.westside.com/collections/gifts-for-him"],
    ["gifts for men", "https://global.westside.com/collections/gifts-for-him"],
    ["men gift", "https://global.westside.com/collections/gifts-for-him"],
    ["men gifts", "https://global.westside.com/collections/gifts-for-him"],
    ["mens gift", "https://global.westside.com/collections/gifts-for-him"],

    ["co-ord set", "https://global.westside.com/collections/co-ord-set"],
    ["coord set", "https://global.westside.com/collections/co-ord-set"],
    ["co-ord set", "https://global.westside.com/collections/co-ord-set"],
    ["coordset", "https://global.westside.com/collections/co-ord-set"],
    ["cordset", "https://global.westside.com/collections/co-ord-set"],
    ["western co-ord set", "https://global.westside.com/collections/co-ord-set"],
    ["casual co-ord set", "https://global.westside.com/collections/co-ord-set"],
    ["western coord set", "https://global.westside.com/collections/co-ord-set"],
    [
      "casual western coord set",
      "https://global.westside.com/collections/co-ord-set",
    ],
    ["coord sets for women", "https://global.westside.com/collections/co-ord-set"],
    ["coordinate sets", "https://global.westside.com/collections/co-ord-set"],
    ["co ord set for women", "https://global.westside.com/collections/co-ord-set"],
    ["cord sets", "https://global.westside.com/collections/co-ord-set"],
    ["coord sets", "https://global.westside.com/collections/co-ord-set"],
    ["co-ordinate sets", "https://global.westside.com/collections/co-ord-set"],
    ["co-ord sets", "https://global.westside.com/collections/co-ord-set"],
    ["coord sets", "https://global.westside.com/collections/co-ord-set"],
    ["co-ord sets", "https://global.westside.com/collections/co-ord-set"],
    ["coordsets", "https://global.westside.com/collections/co-ord-set"],
    ["cordsets", "https://global.westside.com/collections/co-ord-set"],
    ["western co-ord sets", "https://global.westside.com/collections/co-ord-set"],
    ["casual co-ord sets", "https://global.westside.com/collections/co-ord-set"],
    ["western coord sets", "https://global.westside.com/collections/co-ord-set"],
    [
      "casual western coord sets",
      "https://global.westside.com/collections/co-ord-set",
    ],
    ["cord set women", "https://global.westside.com/collections/co-ord-set"],
    ["codset", "https://global.westside.com/collections/co-ord-set"],
    ["cod set", "https://global.westside.com/collections/co-ord-set"],
    ["co ordinate sets", "https://global.westside.com/collections/co-ord-set"],
    ["women cord set", "https://global.westside.com/collections/co-ord-set"],
    [
      "co ord sets for women",
      "https://global.westside.com/collections/co-ord-set",
    ],
    ["women co-ord set", "https://global.westside.com/collections/co-ord-set"],
    ["women coord set", "https://global.westside.com/collections/co-ord-set"],
    ["women co-ord set", "https://global.westside.com/collections/co-ord-set"],
    ["women coordset", "https://global.westside.com/collections/co-ord-set"],
    ["women cordset", "https://global.westside.com/collections/co-ord-set"],
    [
      "women western co-ord set",
      "https://global.westside.com/collections/co-ord-set",
    ],
    [
      "women casual co-ord set",
      "https://global.westside.com/collections/co-ord-set",
    ],
    [
      "women western coord set",
      "https://global.westside.com/collections/co-ord-set",
    ],
    [
      "women casual western coord set",
      "https://global.westside.com/collections/co-ord-set",
    ],
    [
      "women coordinate sets",
      "https://global.westside.com/collections/co-ord-set",
    ],
    ["women cord sets", "https://global.westside.com/collections/co-ord-set"],
    ["women coord sets", "https://global.westside.com/collections/co-ord-set"],
    [
      "women co-ordinate sets",
      "https://global.westside.com/collections/co-ord-set",
    ],
    ["women co-ord sets", "https://global.westside.com/collections/co-ord-set"],
    ["women coord sets", "https://global.westside.com/collections/co-ord-set"],
    ["women co-ord sets", "https://global.westside.com/collections/co-ord-set"],
    ["women coordsets", "https://global.westside.com/collections/co-ord-set"],
    ["women cordsets", "https://global.westside.com/collections/co-ord-set"],
    [
      "women western co-ord sets",
      "https://global.westside.com/collections/co-ord-set",
    ],
    [
      "women casual co-ord sets",
      "https://global.westside.com/collections/co-ord-set",
    ],
    [
      "women western coord sets",
      "https://global.westside.com/collections/co-ord-set",
    ],
    [
      "women casual western coord sets",
      "https://global.westside.com/collections/co-ord-set",
    ],
    ["women codset", "https://global.westside.com/collections/co-ord-set"],
    ["women cod set", "https://global.westside.com/collections/co-ord-set"],
    [
      "women co ordinate sets",
      "https://global.westside.com/collections/co-ord-set",
    ],
    [
      "ethnic co-ord sets for women",
      "https://global.westside.com/collections/ethnic-co-ord-sets-for-women",
    ],
    [
      "cotton linen ethnic co-ord sets for women",
      "https://global.westside.com/collections/ethnic-co-ord-sets-for-women",
    ],
    [
      "ethnic co-ord-set",
      "https://global.westside.com/collections/ethnic-co-ord-sets-for-women",
    ],
    [
      "ethnic coord set",
      "https://global.westside.com/collections/ethnic-co-ord-sets-for-women",
    ],
    [
      "ethnic co-ord set",
      "https://global.westside.com/collections/ethnic-co-ord-sets-for-women",
    ],
    [
      "ethnic coordset",
      "https://global.westside.com/collections/ethnic-co-ord-sets-for-women",
    ],
    [
      "ethnic cordset",
      "https://global.westside.com/collections/ethnic-co-ord-sets-for-women",
    ],
    [
      "ethnic casual co-ord set",
      "https://global.westside.com/collections/ethnic-co-ord-sets-for-women",
    ],
    [
      "ethnic co-ord setss for women",
      "https://global.westside.com/collections/ethnic-co-ord-sets-for-women",
    ],
    [
      "cotton linen ethnic co-ord setss for women",
      "https://global.westside.com/collections/ethnic-co-ord-sets-for-women",
    ],
    [
      "ethnic co-ord-sets",
      "https://global.westside.com/collections/ethnic-co-ord-sets-for-women",
    ],
    [
      "ethnic coord sets",
      "https://global.westside.com/collections/ethnic-co-ord-sets-for-women",
    ],
    [
      "ethnic co-ord sets",
      "https://global.westside.com/collections/ethnic-co-ord-sets-for-women",
    ],
    [
      "ethnic coordsets",
      "https://global.westside.com/collections/ethnic-co-ord-sets-for-women",
    ],
    [
      "ethnic cordsets",
      "https://global.westside.com/collections/ethnic-co-ord-sets-for-women",
    ],
    [
      "ethnic casual co-ord sets",
      "https://global.westside.com/collections/ethnic-co-ord-sets-for-women",
    ],
    [
      "ethnic coord sets for women",
      "https://global.westside.com/collections/ethnic-co-ord-sets-for-women",
    ],
    [
      "ethnic cord set women",
      "https://global.westside.com/collections/ethnic-co-ord-sets-for-women",
    ],
    [
      "ethnic codset",
      "https://global.westside.com/collections/ethnic-co-ord-sets-for-women",
    ],
    [
      "ethnic cod set",
      "https://global.westside.com/collections/ethnic-co-ord-sets-for-women",
    ],
    [
      "ethnic co ordinate sets",
      "https://global.westside.com/collections/ethnic-co-ord-sets-for-women",
    ],
    [
      "ethnic women cord set",
      "https://global.westside.com/collections/ethnic-co-ord-sets-for-women",
    ],
    [
      "women ethnic co-ord-set",
      "https://global.westside.com/collections/ethnic-co-ord-sets-for-women",
    ],
    [
      "women ethnic coord set",
      "https://global.westside.com/collections/ethnic-co-ord-sets-for-women",
    ],
    [
      "women ethnic co-ord set",
      "https://global.westside.com/collections/ethnic-co-ord-sets-for-women",
    ],
    [
      "women ethnic coordset",
      "https://global.westside.com/collections/ethnic-co-ord-sets-for-women",
    ],
    [
      "women ethnic cordset",
      "https://global.westside.com/collections/ethnic-co-ord-sets-for-women",
    ],
    [
      "women ethnic casual co-ord set",
      "https://global.westside.com/collections/ethnic-co-ord-sets-for-women",
    ],
    [
      "women ethnic co-ord-sets",
      "https://global.westside.com/collections/ethnic-co-ord-sets-for-women",
    ],
    [
      "women ethnic coord sets",
      "https://global.westside.com/collections/ethnic-co-ord-sets-for-women",
    ],
    [
      "women ethnic co-ord sets",
      "https://global.westside.com/collections/ethnic-co-ord-sets-for-women",
    ],
    [
      "women ethnic coordsets",
      "https://global.westside.com/collections/ethnic-co-ord-sets-for-women",
    ],
    [
      "women ethnic cordsets",
      "https://global.westside.com/collections/ethnic-co-ord-sets-for-women",
    ],
    [
      "women ethnic casual co-ord sets",
      "https://global.westside.com/collections/ethnic-co-ord-sets-for-women",
    ],
    [
      "women ethnic codset",
      "https://global.westside.com/collections/ethnic-co-ord-sets-for-women",
    ],
    [
      "women ethnic cod set",
      "https://global.westside.com/collections/ethnic-co-ord-sets-for-women",
    ],
    [
      "women ethnic co ordinate sets",
      "https://global.westside.com/collections/ethnic-co-ord-sets-for-women",
    ],
    [
      "kurta sets",
      "https://global.westside.com/collections/vark-woman-ethnic-wear",
    ],
    [
      "kurta set",
      "https://global.westside.com/collections/vark-woman-ethnic-wear",
    ],

    [
      "pome lab",
      "https://global.westside.com/blogs/stories/pome-lab-grown-diamond-jewellery-from-westside",
    ],
    [
      "pome lab-grown diamond jewellery",
      "https://global.westside.com/blogs/stories/pome-lab-grown-diamond-jewellery-from-westside",
    ],
    [
      "pome jewellery",
      "https://global.westside.com/blogs/stories/pome-lab-grown-diamond-jewellery-from-westside",
    ],
    [
      "pome lab diamond jewellery",
      "https://global.westside.com/blogs/stories/pome-lab-grown-diamond-jewellery-from-westside",
    ],
    [
      "lab grown diamond jewellery",
      "https://global.westside.com/blogs/stories/pome-lab-grown-diamond-jewellery-from-westside",
    ],
    [
      "lab grown diamond",
      "https://global.westside.com/blogs/stories/pome-lab-grown-diamond-jewellery-from-westside",
    ],
    [
      "night suit",
      "https://global.westside.com/collections/loungewear-and-sleepwear",
    ],
    // [
    //   "night suit for women",
    //   "https://global.westside.com/collections/loungewear-and-sleepwear",
    // ],
    [
      "women night suit",
      "https://global.westside.com/collections/loungewear-and-sleepwear",
    ],
    ["christmas", "https://global.westside.com/collections/home"],
    ["xmas", "https://global.westside.com/collections/home"],
    ["critsmas", "https://global.westside.com/collections/christmas"],
    ["chritmas", "https://global.westside.com/collections/christmas"],
    ["giift", "https://global.westside.com/pages/gift-shop"],
    ["christmas gifts", "https://global.westside.com/pages/gift-shop"],
    ["gift for men", "https://global.westside.com/pages/gift-shop"],
    ["gift for women", "https://global.westside.com/pages/gift-shop"],
    ["gift for kid", "https://global.westside.com/pages/gift-shop"],
    ["gift for kids", "https://global.westside.com/pages/gift-shop"],
    ["gift for boy", "https://global.westside.com/pages/gift-shop"],
    ["gift for girl", "https://global.westside.com/pages/gift-shop"],
    [
      "beauty gift",
      "https://global.westside.com/collections/gifts-for-makeup-lovers",
    ],
    [
      "beauty gifts",
      "https://global.westside.com/collections/gifts-for-makeup-lovers",
    ],
    ["gift for home", "https://global.westside.com/collections/gifts-for-house"],
    ["home gift", "https://global.westside.com/collections/gifts-for-house"],
    ["house gift", "https://global.westside.com/collections/gifts-for-house"],
    ["gift for mom", "	https://global.westside.com/collections/mothers-day-gift"],
    [
      "gift for mother",
      "https://global.westside.com/collections/mothers-day-gift",
    ],
    ["gift for dad", "https://global.westside.com/collections/gifts-for-father"],
    [
      "gift for father",
      "https://global.westside.com/collections/gifts-for-father",
    ],
    [
      "christmas home lookbook",
      "https://global.westside.com/pages/christmas-home-lookbook",
    ],
    [
      "feels a lot like christmas",
      "https://global.westside.com/pages/christmas-home-lookbook",
    ],
    [
      "feels like christmas",
      "	https://global.westside.com/pages/christmas-home-lookbook",
    ],
    // [
    //   "pome",
    //   "https://global.westside.com/collections/lab-grown-diamond-jewellery",
    // ],
    [
      "pome lab",
      "	https://global.westside.com/collections/lab-grown-diamond-jewellery",
    ],
    [
      "pome lab-grown diamond jewellery",
      "	https://global.westside.com/collections/lab-grown-diamond-jewellery",
    ],
    [
      "pome jewellery",
      "	https://global.westside.com/collections/lab-grown-diamond-jewellery",
    ],
    [
      "pome lab diamond jewellery",
      "	https://global.westside.com/collections/lab-grown-diamond-jewellery",
    ],
    [
      "lab grown diamond jewellery",
      "	https://global.westside.com/collections/lab-grown-diamond-jewellery",
    ],
    [
      "lab grown diamond",
      "	https://global.westside.com/collections/lab-grown-diamond-jewellery",
    ],
    [
      "pome diamond jewellery",
      "	https://global.westside.com/collections/lab-grown-diamond-jewellery",
    ],
    [
      "lab diamond jewellery",
      "https://global.westside.com/collections/lab-grown-diamond-jewellery",
    ],
    [
      "pome diamond jewellery",
      "	https://global.westside.com/collections/lab-grown-diamond-jewellery",
    ],
    [
      "diamond jewellery",
      "	https://global.westside.com/collections/lab-grown-diamond-jewellery",
    ],
    [
      "pome blog",
      "	https://global.westside.com/blogs/stories/pome-lab-grown-diamond-jewellery-from-westside",
    ],
    [
      "pome diamond jewellery blog",
      "	https://global.westside.com/blogs/stories/pome-lab-grown-diamond-jewellery-from-westside",
    ],
    [
      "pome lab diamond jewellery blog",
      "	https://global.westside.com/blogs/stories/pome-lab-grown-diamond-jewellery-from-westside",
    ],
    [
      "diamond jewellery blog",
      "	https://global.westside.com/blogs/stories/pome-lab-grown-diamond-jewellery-from-westside",
    ],
    [
      "jewellery blog",
      "https://global.westside.com/blogs/stories/pome-lab-grown-diamond-jewellery-from-westside",
    ],
    ["gift cards", "https://westside.woohoo.in/en-in/e-gift-card/westside-egc"],
    [
      "gift vouchers",
      "https://westside.woohoo.in/en-in/e-gift-card/westside-egc",
    ],
    [
      "westside egv",
      "https://westside.woohoo.in/en-in/e-gift-card/westside-egc",
    ],
    ["gift card", "https://westside.woohoo.in/en-in/e-gift-card/westside-egc"],
    ["giftcard", "https://westside.woohoo.in/en-in/e-gift-card/westside-egc"],
    ["giftcards", "https://westside.woohoo.in/en-in/e-gift-card/westside-egc"],
    ["egv", "https://westside.woohoo.in/en-in/e-gift-card/westside-egc"],
     ["pet", "https://global.westside.com/collections/pet"],
  ["pets", "https://global.westside.com/collections/pet"],
  ["animal", "https://global.westside.com/collections/pet"],
  ["cat", "https://global.westside.com/collections/pet"],
  ["animals", "https://global.westside.com/collections/pet"],

  ["kurta sets", "https://global.westside.com/collections/ethnic-suits-for-women"],
  ["kurta set", "https://global.westside.com/collections/ethnic-suits-for-women"],
  ["kurta with dupatta", "https://global.westside.com/collections/ethnic-suits-for-women"],
  ["kurti set", "https://global.westside.com/collections/ethnic-suits-for-women"],
  ["kurti sets", "https://global.westside.com/collections/ethnic-suits-for-women"],

  ["ethnic wear for women", "https://global.westside.com/collections/view-all-ethnic-wear-for-women"],
  ["ethnic wear", "https://global.westside.com/collections/view-all-ethnic-wear-for-women"],
  ["ethnic", "https://global.westside.com/collections/view-all-ethnic-wear-for-women"],

  ["tops for women", "https://global.westside.com/collections/shirts-tops"],
  ["top for women", "https://global.westside.com/collections/shirts-tops"],
  ["women tops", "https://global.westside.com/collections/shirts-tops"],
  ["women top", "https://global.westside.com/collections/shirts-tops"],

  ["dresses for women", "https://global.westside.com/collections/dresses-jumpsuits"],
  ["women dresses", "https://global.westside.com/collections/dresses-jumpsuits"],
  ["women dress", "https://global.westside.com/collections/dresses-jumpsuits"],
  ["dress women", "https://global.westside.com/collections/dresses-jumpsuits"],
  ["ladies dresses", "https://global.westside.com/collections/dresses-jumpsuits"],

  ["bags for women", "https://global.westside.com/collections/bags"],
  ["handbags", "https://global.westside.com/collections/bags"],
  ["handbag", "https://global.westside.com/collections/bags"],
  ["bags", "https://global.westside.com/collections/bags"],
  ["bag", "https://global.westside.com/collections/bags"],
  ["women handbag", "https://global.westside.com/collections/bags"],
  ["women bag", "https://global.westside.com/collections/bags"],

  ["kurtas for women", "https://global.westside.com/collections/kurtas-for-women"],
  ["women kurta", "https://global.westside.com/collections/kurtas-for-women"],
  ["kurta for woman", "https://global.westside.com/collections/kurtas-for-women"],
  ["kurta for women", "https://global.westside.com/collections/kurtas-for-women"],

  ["footwear for women", "https://global.westside.com/collections/footwear-for-women"],

  ["formal shirts for men", "https://global.westside.com/collections/formal-shirts-for-men"],
  ["man formal shirts", "https://global.westside.com/collections/formal-shirts-for-men"],
  ["formal shirt men", "https://global.westside.com/collections/formal-shirts-for-men"],

  ["jeans for men", "https://global.westside.com/collections/men-jeans"],
  ["men jeans", "https://global.westside.com/collections/men-jeans"],
  ["jeans men", "https://global.westside.com/collections/men-jeans"],
  ["man jeans", "https://global.westside.com/collections/men-jeans"],

  ["casual shirts for men", "https://global.westside.com/collections/casual-shirts-for-men"],
  ["mens casual shirts", "https://global.westside.com/collections/casual-shirts-for-men"],
  ["casual shirts man", "https://global.westside.com/collections/casual-shirts-for-men"],
  ["man casual shirts", "https://global.westside.com/collections/casual-shirts-for-men"],

  ["tshirts for men", "https://global.westside.com/collections/t-shirts-for-men"],
  ["polo tshirts for men", "https://global.westside.com/collections/polo-t-shirts-for-men"],

  ["jeans for women", "https://global.westside.com/collections/jeans-western-wear-for-women"],
  ["women jeans", "https://global.westside.com/collections/jeans-western-wear-for-women"],

  ["shoes for men", "https://global.westside.com/collections/shoes-for-men"],
  ["men footwear", "https://global.westside.com/collections/shoes-for-men"],
  ["footwear for men", "https://global.westside.com/collections/shoes-for-men"],
  ["men shoes", "https://global.westside.com/collections/shoes-for-men"],
  ["man footwear", "https://global.westside.com/collections/shoes-for-men"],
  ["man shoe", "https://global.westside.com/collections/shoes-for-men"],

  ["swimwear", "https://global.westside.com/collections/lingerie-swimwear"],

  ["tshirts for women", "https://global.westside.com/collections/t-shirts-for-women"],

  ["formal trousers for men", "https://global.westside.com/collections/formal-trousers-for-men"],
  ["men formal trousers", "https://global.westside.com/collections/formal-trousers-for-men"],

  ["monsoon footwear", "https://global.westside.com/collections/monsoon-footwear"],
  ["rainy footwear", "https://global.westside.com/collections/monsoon-footwear"],
  ["waterproof footwear", "https://global.westside.com/collections/monsoon-footwear"],
  ["water-resistant footwear", "https://global.westside.com/collections/monsoon-footwear"],
  ["casual rainy footwear", "https://global.westside.com/collections/monsoon-footwear"],
  ["casual monsoon footwear", "https://global.westside.com/collections/monsoon-footwear"],
  // ["christmas edit","https://global.westside.com/collections/christmas-collection-outfits-gifts-home-décor"],
  ]);
  console.log(q, "url==================>");
  if (redirectByQuery.get(q)) {
    console.log(q, "url==================>");
    return redirectByQuery.get(q);
  }

  return false;
};

const matchQuery = (q) => {
  const diffKeywords = [
    "birthday",
    "birth",
    "birthda",
    "bithday",
    "birthdsy",
    "bithday d",
    "bithday dr",
    "birthday dr",
    "birthday d",
  ];
  let totalKeyWords = diffKeywords.length;
  for (let i = 0; i < totalKeyWords; i++) {
    if (q === diffKeywords[i]) {
      return true;
    }
  }

  return false;
};

// Boosting Collection Pages Sort Order Code Starts
var realPage = 1;
var lastProductId = null;
var boostingDone = false;
var wizzyCollectionProductIds2 = [];
// wizzyCachedFilters Code Starts
var wizzyCachedFilters = null;
// wizzyCachedFilters Code Ends
// Boosting Collection Pages Sort Order Code Ends

window.onWizzyScriptLoaded = function () {
  if (document.documentElement.clientWidth > 768) {
    $("body").on("click", ".wizzy-common-select-selector", function (e) {
      let x = document.querySelector(".wizzy-filters-bg");
      if (x) x.click();
    });
  }

  $("body").on("click", "#wizzy-custom-swatch-click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    location.href = $(this).data("swatch-url");
  });

  $("body").on("click", ".wizzy-mobile-facets-show-results", function (e) {
    $(".wizzy-filters-bg").click();
  });

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
      // console.log(
      //   "==========BEFORE_INIT===============",
      //   data.search.configs.sorts.configs
      // );
      sessionStorage.setItem("wizzy-2-products-in-a-row", false);
      sessionStorage.setItem("wizzy-4-products-in-a-row", true);
      sessionStorage.setItem("wizzy-6-products-in-a-row", false);
      // data.endpoints.common = "https://westside-api.wizsearch.in";

      if (window.location.pathname.includes("/collections/")) {
        data.common.isOnCategoryPage = true;
      }

      data.store.currency.symbol = "₹ ";

      data["filters"] = [];
      data["filters"]["configs"] = [];
      data["filters"]["configs"]["keepOpenedInMobileAfterApply"] = true;
      if (document.documentElement.clientWidth > 768) {
        data["filters"]["configs"]["displayAsDrawer"] = true;
        data["filters"]["configs"]["drawerPosition"] = "right";
      }
      /*for grid filters - starts here*/
      data["search"]["view"]["templates"]["facets"]["gridFilterCommon"] =
        "#wizzy-grid-facet-block";
      data["gridFilters"] = {
        enabled: true,
        filters: [
          {
            key: "product_value_tags_occasion_new",
            question: "Select your outfit based on occasion",
            after: { web: 12, mobile: 6 },
          },
          {
            key: "genders",
            question: "Gender",
            after: { web: 24, mobile: 12 },
          },
          {
            key: "colors",
            question: "Select your color",
            after: { web: 36, mobile: 18 },
          },
          {
            key: "product_value_tags_fabric_new",
            question: "Fabric Material",
            after: { web: 48, mobile: 24 },
          },
        ],
      };

      if(wizzyConfig.common.collectionHandle == "ethnic-wear-for-diwali-2025") {
        data["gridFilters"] = {
        enabled: true,
        filters: [
          {
            key: "product_Wizzy_Occasion_Product",
            question: "Select your outfit based on occasion",
            after: { web: 12, mobile: 6 },
          },
          {
            key: "product_Wizzy_Color_Product",
            question: "Select your color",
            after: { web: 24, mobile: 12 },
          },
          {
            key: "product_Wizzy_Fabric_Product",
            question: "Fabric Material",
            after: { web: 36, mobile: 18 },
          },
          {
            key: "genders",
            question: "Gender",
            after: { web: 48, mobile: 24 },
          },
        ],
      };
      }
      /*for grid filters - ends here*/

      data.search.configs.facets.leftFacets.defaultCollapsed = true;
      data.search.configs.facets.leftFacets.firstLeftDefaultOpened = false;
      data.search.configs.facets.leftFacets.mobileCollapsible = true;

      // data.search.configs.general.formSubmissionBehaviour = 'redirect_page';
      data.autocomplete.menu.others.title = "Trending Searches";
      data.common.hasToReplaceCollectionPage = true;

      if (typeof data.search.configs.sorts?.configs !== "undefined") {
        let totalSorts = data.search.configs.sorts.configs.length;
        for (let i = 0; i < totalSorts; i++) {
          if (data.search.configs.sorts.configs[i].label === "New Arrivals") {
            data.search.configs.sorts.configs[i].field =
              "product_published_at:datetime";
          }
        }
      }

      if (data["common"]["categoryUrlKey"] !== "") {
        data["common"]["hasToReplaceCollectionPages"] = true;
        data["common"]["isOnCategoryListing"] = true;
        data["common"]["isOnCategoryPage"] = true;
        data.common.lazyDOMConfig.contentDOMIdentifiers[0] =
          "#wizzy-shopify-collection-page-wrapper";

        // const sortUpdate = data.search.configs.sorts.configs.filter(
        //   (item) =>
        //     item.field !== "relevance" && item.field !== "discountPercentage"
        // );
        data.search.configs.sorts.configs = [];
        data.search.configs.sorts.configs = [
          {
            label: "New Arrivals",
            field: "product_published_at:datetime",
            order: "desc",
            isSelected: false,
          },
          {
            label: "Price (Lowest to Highest)",
            field: "sellingPrice",
            order: "asc",
            isSelected: false,
          },
          {
            label: "Price (Highest to Lowest)",
            field: "sellingPrice",
            order: "desc",
            isSelected: false,
          },
        ];
      } else {
        data.search.configs.sorts.configs =
          data.search.configs.sorts.configs.filter((sort) => {
            return sort.field !== "discountPercentage";
          });
      }

      if (document.documentElement.clientWidth <= 768) {
        data.common.lazyDOMConfig.searchInputIdentifiers[0].dom =
          "#Search-In-Modal-1";
        data.common.lazyDOMConfig.searchInputIdentifiers[0].type = "search";
      }

      window.wizzyConfig["search"]["configs"]["pagination"][
        "infiniteScrollOffset"
      ] = {
        desktop: 2000,
        mobile: 3000,
      };
      if(window.wizzyConfig.common.collectionHandle == "online-gift-store-for-newborn-baby" && window.innerWidth > 768) {
        window.wizzyConfig["search"]["configs"]["pagination"][
        "infiniteScrollOffset"
      ] = {
        desktop: 3500,
        mobile: 3000,
      };
      }
      // console.log(data);

      // V1 store credentials - Uncomment it in case of V2 failure, it will switch to V1 store
      // data.credentials.apiKey = "cXVuelRXaTlGQzFQUmJ3VEU5ZllVSzh4YldTQWxBTTQ2K2l4OXhrZmxoSXhzcGFZTjA1YnZJRkNPekVpcE5ERTBHOUhTSEE1TDc2dFIyNkwveFNramc9PQ==";
      // data.credentials.storeId = "fa5abe64dc3011eca5fb0a0c8095feae";

      // wizzyConfig.events.getRegisteredEvents(wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED).shift();

      // Change for internation market - 31-01-2026
      data.store.currency.symbol = "$ ";

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (data) {
      /*changes - 30/12/2024 - starts here*/
      // data.includeOutOfStock = "false";
      /*changes - 30/12/2024 - ends here*/
      if(data.q) {
        data.q = data.q.replace(/[^a-zA-Z0-9 ]/g, '').trim();
      }

      // console.log(data, "<===BEFORE_AUTOCOMPLETE_EXECUTED");

      // if (typeof data.sort != "undefined") {
      //   if (data.sort == "") {
      //     data.sort = [
      //       { field: "relevance", order: "asc" },
      //       { field: "product_published_at:datetime", order: "desc" },
      //     ];
      //   } else {
      //     data.sort.push({
      //       field: "product_published_at:datetime",
      //       order: "desc",
      //     });
      //   }
      // } else {
      //   data.sort = [
      //     { field: "relevance", order: "asc" },
      //     { field: "product_published_at:datetime", order: "desc" },
      //   ];
      // }
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER,
    function (data) {
      // console.log(data, "<====BEFORE_AUTOCOMPLETE_RENDER");
      let x = document.querySelector(".wizzy-body-end-wrapper");
      if (
        x &&
        typeof data.isForDefault !== "undefined" &&
        data.isForDefault === true
      ) {
        x.classList.add("wizzy-view-more-hide");
      } else if (x && x.classList.contains("wizzy-view-more-hide")) {
        x.classList.remove("wizzy-view-more-hide");
      }
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
      /*changes - 30/12/2024 - starts here*/
      data.filters.showOOSProductsInOrder = "true";
      data.filters.inStock = ["true"];
      /*changes - 30/12/2024 - ends here*/

      // data.fW = "yes";

      // Change for internation market - 31-01-2026
      if (window.wizzyConfig?.common?.isOnCategoryPage) {
        fetch(
        `https://global.westside.com${wizzyConfig.common.categoryEndpoint}?view=wizzy-collectionToolbar`
      )
        .then((response) => response.text())
        .then((response) => {
          // alert(`https://global.westside.com${wizzyConfig.common.categoryEndpoint}?view=wizzy-collectionToolbar`);

          // console.log(response.trim(), "response-collection"); // parse JSON data from the response
          const toolbarInterval = setInterval(() => {
            if ($(".collection-pannel").length > 0) {
              console.log("IN");
              $(".collection-pannel").html(response.trim());
              console.log($(".collection-pannel"), "pppppppppppppppp");
              let toolbar_nav_1 = document.querySelector(".toolbar-nav");
              var toolbar_nav_col = new Swiper(toolbar_nav_1, {
                slidesPerView: "auto",
                navigation: {
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                  clickable: true,
                },
              });
              clearInterval(toolbarInterval);
            }
          }, 500);
        })
        .catch((error) => {
          console.error("There was a problem with the fetch operation:", error);
        });
      }

      // Boosting Collection Pages Sort Order Code Starts -- Commented the below code to pass the relevance as first sort for PLP
      
      // let newSort = [];
      // if (wizzyConfig.common.isOnCategoryPage) {
      //   data.filters.sort.forEach((opt) => {
      //     if (opt.field !== "relevance") {
      //       newSort.push(opt);
      //     }
      //     // else {
      //     //   opt.field = "demo";
      //     //   newSort.push(opt);
      //     // }
      //   });
      //   data.filters.sort = newSort;
      // }

      // Boosting Collection Pages Sort Order Code Starts
      

      return data;
    },
    1
  );

  // Boosting Collection Pages Sort Order Code Starts
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
      if (window.wizzyConfig.common.isOnCategoryPage) {
        var hasQueryParams = window.location.search && window.location.search.length > 1;
        data.filters.productsCount = window.wizzyConfig.search.configs.general.noOfProducts;
        var productsCount = data.filters?.productsCount ?? 50;
        var currentPage = realPage ?? 1;
        var totalPages = window.wizzyConfig?.pageStore?.searchedResponse?.pages;
        // wizzyCachedFilters Code Starts
        var hasAttributes = data.filters.attributes && Object.values(data.filters.attributes).some(v => Array.isArray(v) && v.length > 0);
        var hasFloatAttributes = data.filters.floatAttributes && Object.values(data.filters.floatAttributes).some(v => Array.isArray(v) && v.length > 0);
        var hasBrands = data.filters.brands && data.filters.brands.length > 0;
        var hasColors = data.filters.colors && data.filters.colors.length > 0;
        var hasSizes = data.filters.sizes && data.filters.sizes.length > 0;
        var hasSellingPrice = data.filters.sellingPrice && data.filters.sellingPrice.length > 0;
        var hasGenders = data.filters.genders && data.filters.genders.length > 0;
        var hasAnyOtherFilterApplied = hasAttributes || hasBrands || hasColors || hasSizes || hasSellingPrice || hasGenders || hasFloatAttributes;
        console.log("<===== Wizzy BOOST BEFORE hasAnyOtherFilterApplied", hasAttributes, hasBrands, hasSellingPrice, hasGenders, hasAnyOtherFilterApplied);
        console.log("Wizzy realPage before modifying", realPage);
        var filtersChanged = hasFilterStateChanged(data.filters);
        wizzyCachedFilters = {
          attributes: deepClone(data.filters.attributes || {}),
          floatAttributes: deepClone(data.filters.floatAttributes || {}),
          brands: deepClone(data.filters.brands || []),
          colors: deepClone(data.filters.colors || []),
          sizes: deepClone(data.filters.sizes || []),
          sellingPrice: deepClone(data.filters.sellingPrice || []),
          genders: deepClone(data.filters.genders || []),
        };
        setCachedFilters(wizzyCachedFilters);
        // wizzyCachedFilters Code Ends
        if (currentPage === 42) {
          data.filters.page = currentPage;
        }
        // wizzyCachedFilters Code Starts
        if (filtersChanged) {
          realPage = 1;
        }
        if (hasAnyOtherFilterApplied) {
          data.filters.boostGroupIds = [];
        }
        // wizzyCachedFilters Code Ends
        console.log("WIZZY boosting OLD", hasQueryParams, productsCount, currentPage, totalPages, filtersChanged, realPage);
        if (typeof window.inStockProducts != "undefined" && window.inStockProducts && !hasQueryParams && !hasAnyOtherFilterApplied && realPage < 43 && (typeof totalPages === 'undefined' || totalPages > 1) && !boostingDone) {
          if (data.filters && data.filters.sort && data.filters.sort.length > 0 && data.filters.sort[0].field === "relevance" && window.inStockProducts && window.inStockProducts.length > 0) {
            // wizzyCollectionProductIds = wizzyCollectionProductIds.slice(0, productsCount);
            if (realPage === totalPages + 1) {
              data.filters.page = totalPages + 1;
            }
            // var wizzyCollectionProductIds2 = window.inStockWizzyCollectionProductIds1.slice(0, Math.floor(1000 / productsCount) * productsCount);
            // var start = (currentPage - 1) * productsCount;
            // var end = currentPage * productsCount;
            // var wizzyCollectionBoostedProductIds = wizzyCollectionProductIds2.slice(start, end);
            // NEW LOGIC STARTS
            // NEW LOGIC STARTS - 17 OCT
            var adjustedLength = Math.floor(window.inStockProducts.length / productsCount) * productsCount;
            wizzyCollectionProductIds2 = window.inStockProducts.slice(0, adjustedLength);
            // NEW LOGIC ENDS - 17 OCT
            var start = 0;
            if (typeof lastProductId !== "undefined" && lastProductId) {
              var lastIndex = wizzyCollectionProductIds2.indexOf(lastProductId);
              // NEW LOGIC STARTS - 17 OCT
              if (lastProductId === wizzyCollectionProductIds2[wizzyCollectionProductIds2.length - 1]) {
                boostingDone = true;
              }
              // NEW LOGIC ENDS - 17 OCT

              if (lastIndex !== -1) {
                start = lastIndex + 1; // start after the last used product
              }
            } else {
              // fallback to old pagination if no lastProductId available
              start = (currentPage - 1) * productsCount;
            }
            var end = (currentPage * productsCount) + productsCount;
            var wizzyCollectionBoostedProductIds = wizzyCollectionProductIds2.slice(start, end);
            if (wizzyCollectionBoostedProductIds.length > 50) {
              wizzyCollectionBoostedProductIds = wizzyCollectionBoostedProductIds.slice(0, 50);
            }
            // NEW LOGIC STARTS - 17 OCT
            if (wizzyCollectionBoostedProductIds.length === 0) {
              boostingDone = true;
            }
            // NEW LOGIC ENDS - 17 OCT
            // NEW LOGIC ENDS
            console.log("WIZZY boosting", wizzyCollectionProductIds2, start, end, wizzyCollectionBoostedProductIds);
            if (wizzyCollectionBoostedProductIds.length > 0) {
              realPage++;
            // console.log("WIZZY boosting 1", realPage);
              data.filters.boostGroupIds = wizzyCollectionBoostedProductIds;
              if (totalPages) {
                if (realPage !== totalPages + 2) {
                  data.filters.page = 1;
                }
              }
              if (wizzyCollectionBoostedProductIds.length < productsCount) {
                data.filters.productsCount = wizzyCollectionBoostedProductIds.length;
              }
            }
          } else {
            realPage++;
          }
        } else {
          // NEW LOGIC STARTS - 17 OCT
            console.log("WIZZY boosting aaaaaaaa", realPage, data.filters.page);
            data.filters.page = realPage;
          realPage++;
          // NEW LOGIC ENDS - 17 OCT
        }
      }
      
      return data;
    }, 3
  );
  // Boosting Collection Pages Sort Order Code Ends
  
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
      if (
        wizzyConfig.common.isOnCategoryPage &&
        wizzyConfig.common.collectionHandle
      ) {
        // data.filters.type = "CATEGORY_PAGE";
        var collectionFilterTree = JSON.parse(
          window.wizzyCollectionsFiltersTree
        );

        const updatedFacets = collectionFilterTree[
          wizzyConfig.common.collectionHandle
        ]?.facets.map(({ field, ...rest }) => ({
          ...rest,
          key: field,
        }));
        console.log("SHREY --> ", updatedFacets, serachFacetList);
        data.filters.facets = updatedFacets || serachFacetList;
        // let colName = childParentMap.get(wizzyConfig.common.collectionHandle);
        // if (colName) {
        //   // console.log(
        //   //   getFilterArray(collectionFilterMap.get(colName)),
        //   //   "newfacet"
        //   // );
        //   data.filters.facets = getFilterArray(
        //     collectionFilterMap.get(colName)
        //   );
        //   console.log(
        //     collectionFilterMap.get(colName),
        //     "before filter==========>"
        //   );
        // }
      } else {
        data.filters.facets = serachFacetList;
      }
      /*changes - 30/12/2024 - starts here*/
      if (data && data.filters && Array.isArray(data.filters.facets)) {
        // Check if the key "product_value_tags_wizzy_sale" already exists
        const keyExists = data.filters.facets.some(
          (facet) => facet.key === "product_wizzy_sale_custom"
        );

        // Push the new object only if the key does not exist
        // if (!keyExists) {
        //   data.filters.facets.push({
        //     label: "Price Type",
        //     key: "product_wizzy_sale_custom",
        //     position: "left",
        //     order: 0,
        //   });
        // }
      }
      /*changes - 30/12/2024 - ends here*/
      if (
        Array.isArray(data.filters.facets) &&
        wizzyConfig.common.isOnCategoryPage &&
        (wizzyConfig.common.collectionHandle === "view-all-kids" ||
          wizzyConfig.common.collectionHandle === "trending-now-kidswear" ||
          wizzyConfig.common.collectionHandle === "new-in-kids")
      ) {
        // Check if the key "product_value_tags_wizzy_sale" already exists
        const keyExists = data.filters.facets.some(
          (facet) => facet.key === "product_value_tags_kid_size"
        );

        // Push the new object only if the key does not exist
        if (!keyExists) {
          data.filters.facets.push({
            label: "Kid Size",
            key: "product_value_tags_kid_size",
            position: "left",
            order: 40,
          });
        }

        window.wizzyConfig.gridFilters.filters.push({
          key: "product_value_tags_kid_size",
          question: "Which Kid Size are you looking for?",
          after: {
            web: 12,
            mobile: 6,
          },
        });
      }

      // Change for internation market - 31-01-2026
      if (wizzyConfig.common.isOnCategoryPage &&
        wizzyConfig.common.collectionHandle) {
          const facets = data?.filters?.facets;
          if (Array.isArray(facets)) {
            data.filters.facets = data.filters.facets.map(facet => {
              if (facet.key === "product_Wizzy_Price_Range_Product") {
                return { ...facet, key: "product_value_tags_price_usd" };
              }
              return facet;
            });
          } else if (facets && typeof facets === "object") {
            Object.keys(facets).forEach(key => {
              if (key === "product_Wizzy_Price_Range_Product") {
                facets["product_value_tags_price_usd"] = {
                  ...facets[key],
                  key: "product_value_tags_price_usd",
                };
                delete facets[key];
              }
            });
          }
        }

      console.log(data.filters.facets);
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
      // data.fW = "no";
      // data.facets = serachFacetList;
      data.attributeFacetValuesLimit = 50;
      if(data.q) {
        data.q = data.q.replace(/[^a-zA-Z0-9 ]/g, '').trim();
      }
        
      // console.log(data,"==========>before search")
      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
      data.filters.attributeFacetValuesLimit = 50;
      let inputBox = document.querySelector(
        ".field__input.header-search__input"
      );
      if (typeof inputBox !== "undefined" && inputBox) {
        inputBox.blur();
      }

      if (data.group === "defaultMenu" && data.filters && data.filters.sort) {
        data.filters.sort = [
          { field: "relevance", order: "asc" },
          {
            field: "product_wizzy-pinned-products_sortOrder:float",
            order: "asc",
          },
        ];
      } else if (
        data.group === "noProductsFound" &&
        data.filters &&
        data.filters.sort
      ) {
        data.filters.sort = [
          {
            field: "product_view-all-western-wear-for-women_sortOrder:float",
            order: "asc",
          },
          { field: "relevance", order: "asc" },
        ];
      } else if (
        !wizzyConfig.common.isOnCategoryPage &&
        data.filters &&
        data.filters.sort
      ) {
        let sortLength = data.filters.sort.length;
        let publishedSortExists = false;
        for (let i = 0; i < sortLength; i++) {
          if (data.filters.sort[i].field === "product_published_at:datetime") {
            publishedSortExists = true;
          }
        }
        // if (!publishedSortExists) {
        //   data.filters.sort.push({
        //     field: "product_published_at:datetime",
        //     order: "desc",
        //   });
        // }
      }
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
      // data.facets = serachFacetList;
      
      // console.log(data.sort,"Before search");
      if (data.sort && data.sort.length && data.sort[0].field == "relevance") {
        addSorting(data);
      }

      return data;
    }, 1
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (data) {
      // console.log(data.sort,"Before search");
      // if(data.sort&&data.sort.length&&data.sort[0].field=='relevance')
      // {
      addSorting(data);
      // }

      return data;
    }, 1
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
      // console.log(data.filters,"Before filter");
      if(data?.filters?.q) {
        data.filters.q = data.filters.q.replace(/[^a-zA-Z0-9 ]/g, '').trim();
      }
      if (
        data.filters.sort &&
        data.filters.sort.length &&
        data.filters.sort[0].field == "relevance"
      ) {
        // addSorting(data.filters);
      }
      // if (
      //         data.filters.sort &&
      //         data.filters.sort.length &&
      //         data.filters.sort[0].field == "relevance" && wizzyConfig.common.isOnCategoryPage
      //       ) {
      //         addCollectionSorting(data.filters);
      //       }
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
      /*changes - 30/12/2024 - starts here*/
      // data.includeOutOfStock = "false";
      data.showOOSProductsInOrder = "true";
      /*changes - 30/12/2024 - end here*/

      const breadcrumbsList = document.querySelector(".breadcrumbs__list");
      const featuredStoryView = document.querySelector(
        "#init-wizzy-featured-view-button"
      );
      const collectionDescription = document.querySelector(
        ".wizzy-collection-description"
      );
      // Check if the element was found
      if (breadcrumbsList) {
        // Set its display property to 'none' to hide it
        breadcrumbsList.style.display = "none";
      }
      if (featuredStoryView) {
        // Set its display property to 'none' to hide it
        featuredStoryView.style.display = "none";
      }
      if (collectionDescription) {
        // Set its display property to 'none' to hide it

        collectionDescription.style.display = "none";
      }
      // console.log(data, "<===BEFORE_SEARCH_EXECUTED");
      if (data.q) {
        data.q = data.q.toLowerCase();
      }

      let inputBox = document.querySelector(
        ".field__input.header-search__input"
      );
      if (typeof inputBox !== "undefined" && inputBox) {
        inputBox.blur();
      }

      // if (data.sort) {
      //   data.sort.push({
      //     field: "product_published_at:datetime",
      //     order: "desc",
      //   });
      // } else {
      //   data.sort = [
      //     { field: "product_published_at:datetime", order: "desc" },
      //     { field: "relevance", order: "asc" },
      //   ];
      // }

      if (data && data.q) {
        let currentQuery = data.q.toLowerCase();
        if (matchQuery(currentQuery)) {
          data.q = "";
          window.location.href =
            "https://westside.woohoo.in/en-in/e-gift-card/westside-birthday-e-gift-card-processing";
        }

        let redirectUrl = bulkQueryRedirect(currentQuery);
        console.log(redirectUrl);
        if (redirectUrl !== false) {
          data.q = "";
          window.location.href = redirectUrl;
        }
      }

      let headerEle = document.querySelector("header");
      if (headerEle) headerEle.classList.add("header-bg");

      var breadcrumb = document.querySelector('#wizzy-shopify-collection-page-wrapper .collection-pannel');
      if (breadcrumb) {
        breadcrumb.style.display = 'none';
      }

      var collectionBanner = document.querySelector('.wizzy-search-results-rendered .main_banner_content');

      if (collectionBanner) {
        var parent1 = collectionBanner.parentElement;
        var parent2 = parent1?.parentElement;
        var parent3 = parent2?.parentElement;
      
        if (
          parent2 &&
          parent2.classList.contains('shopify-section') &&
          parent3 &&
          parent3.id === 'MainContent'
        ) {
          parent2.style.display = 'none';
        }
      }
        
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents
      .BEFORE_AUTOCOMPLETE_SUGGESTIONS_RENDER,
    function (data) {
      // console.log(data, "<===BEFORE_AUTOCOMPLETE_SUGGESTIONS_RENDER");
      if (data.hasSuggestions) {
        let visited = [];

        data.suggestions = data.suggestions.filter((item) => {
          let flag = true;
          if (item.isHead === false) {
            flag =
              typeof visited[item.label.toLowerCase()] === "undefined"
                ? true
                : false;
            visited[item.label.toLowerCase()] = true;
          }

          return flag;
        });

        let removeUnnecessaryIndices = [];
        let totalSuggestions = data.suggestions.length;
        for (let i = 1; i < totalSuggestions; i++) {
          if (data.suggestions[i - 1].isHead && data.suggestions[i].isHead) {
            removeUnnecessaryIndices[i - 1] = true;
          }
        }

        data.suggestions = data.suggestions.filter((item, index) => {
          return removeUnnecessaryIndices[index] !== true;
        });
      }
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
    function (payload) {
      $("html").removeClass("filtersOpend");

      const swiper = new Swiper(".swiper-container", {
        loop: false,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          type: "bullets",
        },
        autoHeight: true,
        spaceBetween: "30",
      });

      const x = document.querySelector(".swiper").swiper;

      const rangeInputForGrid = document.querySelector(".wizzy-range-for-grid");
      if (
        sessionStorage.getItem("wizzy-2-products-in-a-row") === "true" &&
        rangeInputForGrid != null &&
        typeof rangeInputForGrid != "undefined"
      ) {
        rangeInputForGrid.value = 2;
        handleRangeInputValueChange(2);
      } else if (
        sessionStorage.getItem("wizzy-4-products-in-a-row") === "true" &&
        rangeInputForGrid != null &&
        typeof rangeInputForGrid != "undefined"
      ) {
        rangeInputForGrid.value = 4;
        handleRangeInputValueChange(4);
      } else if (
        sessionStorage.getItem("wizzy-6-products-in-a-row") === "true" &&
        rangeInputForGrid != null &&
        typeof rangeInputForGrid != "undefined"
      ) {
        rangeInputForGrid.value = 6;
        handleRangeInputValueChange(6);
      }

      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (payload) {
      // Select the elements
      console.log(payload,"wizz view rendered=====>");
      
      /*click event for reset button - starts here */
      const resetBtn = document.querySelector(
        ".wizzy-search-results-wrapper .wizzy-search-filters-left .wizzy-search-filters-left-wrapper .wizzy-filters-reset"
      );
      const clearAllBtn = document.querySelector(
        ".wizzy-search-results-wrapper .wizzy-search-filters-left .wizzy-filters-header .wizzy-filters-clear-all"
      );
      const cancleBtn = document.querySelector(
        ".wizzy-search-results-wrapper .wizzy-search-filters-left .wizzy-filters-close-btn"
      );
      // resetBtn.addEventListener("click", function (e) {
      //   if (clearAllBtn) {
      //     clearAllBtn.click();
      //     var pageNumber = payload?.data?.response?.payload?.filters?.page;
      //     if (pageNumber) {
      //       payload.data.response.payload.filters.page = 1;
      //       // Boosting Collection Pages Sort Order Code Starts
      //       realPage = 1;
      //       // Boosting Collection Pages Sort Order Code Ends
      //     }
      //   } else {
      //     cancleBtn.click();
      //   }
      // });
      // const priceFilterSlider = document.querySelector(".wizzy-facet-range-slider");
      // if(priceFilterSlider) {
      //   priceFilterSlider.noUiSlider.on("change", function (values, handle) {
      //     console.log("price filter from view rendered");
      //     realPage = 1;
      //   });
      // }
      // console.log("priceFilterSlider : ",priceFilterSlider,priceFilterSlider.noUiSlider);
      if(resetBtn && !resetBtn.classList.contains("wizzy-click-event-attached")) { // So that event will not attached more than one time
        resetBtn.classList.add("wizzy-click-event-attached");
        resetBtn.addEventListener("click", function (e) {
          if (clearAllBtn) {
            clearAllBtn.click();
            // var pageNumber = payload?.data?.response?.payload?.filters?.page;
            // if (pageNumber) {
            //   payload.data.response.payload.filters.page = 1;
            //   // Boosting Collection Pages Sort Order Code Starts
            //   realPage = 1;
            //   // Boosting Collection Pages Sort Order Code Ends
            // }
          } else {
            cancleBtn.click();
          }
        });
      }
      /*click event for reset button - ends here */
      
      if (window.innerWidth > 768) {
        const selectedItem = document.querySelector(
          ".wizzy-common-select-selectedItem"
        );

        // console.log(selectedItem,payload,"view rendered=====>");
        if (
          (selectedItem &&
            selectedItem.innerText.trim().toLowerCase() === "recommended") ||
          selectedItem.innerText.trim().toLowerCase() == ""
        ) {
          selectedItem.innerText = "SORT";
        }

        var container = document.querySelector(
          ".wizzy-common-select-container"
        );
        var drawer = document.querySelector(".wizzy-search-filters-drawer");
        var wrapper = document.querySelector(".wizzy-common-select-wrapper");

        if (container && drawer) {
          var width = window.getComputedStyle(container).width;
          var widthNumber = parseFloat(width);
          console.log(widthNumber, "============>widthNumber");
          var newRight;
          if (wizzyConfig.common.isOnCategoryPage) newRight = widthNumber + 50;
          else newRight = widthNumber + 50;

          drawer.style.right = newRight + "px";
          wrapper.style.width = newRight - 30 + "px";
        } else {
          console.log("One or both elements not found");
        }
      }

      if (window.location.href.includes("collections/")) {
        // Change the page title to 'Collection'
        document.title = window.moeApp.meta.title;
      }

      /* Change for internation market - 31-01-2026 */
      // let scrollToTopBtn = document.querySelector(
      //   ".main-content .wizzy-scroll-to-top-wrapper"
      // );
      let scrollToTopBtn = document.querySelector(
        ".wizzy-main-content .wizzy-scroll-to-top-wrapper"
      );

      // When the user scrolls down 20px from the top of the document, show the button
      window.onscroll = function () {
        scrollFunction();
      };
      function scrollFunction() {
        if (
          document.body.scrollTop > 20 ||
          document.documentElement.scrollTop > 20
        ) {
          scrollToTopBtn.style.display = "block";
        } else {
          scrollToTopBtn.style.display = "none";
        }
      }

      /*changes*/
      var gendermenactive = document.querySelector(
        ".wizzy-gender-top-filter .wizzy-gender-top-men-filter"
      );
      var gendermenfilteractive = document.querySelector(
        '.wizzy-facet-body.facet-body-genders [data-key="_Men"]'
      );

      if (gendermenfilteractive) {
        var gendermenspan = document.querySelector(
          ".wizzy-gender-top-filter .wizzy-gender-top-men-filter"
        );
        if (gendermenspan) {
          gendermenspan.textContent = "Man";
        }
        if (gendermenfilteractive.classList.contains("active")) {
          gendermenactive.classList.add("active");
        }
      }

      var genderwomenactive = document.querySelector(
        ".wizzy-gender-top-filter .wizzy-gender-top-women-filter"
      );
      var genderwomenfilteractive = document.querySelector(
        '.wizzy-facet-body.facet-body-genders [data-key="_Women"]'
      );

      if (genderwomenfilteractive) {
        var genderwomenspan = document.querySelector(
          ".wizzy-gender-top-filter .wizzy-gender-top-women-filter"
        );
        if (genderwomenspan) {
          genderwomenspan.textContent = "Women";
        }
        if (genderwomenfilteractive.classList.contains("active")) {
          genderwomenactive.classList.add("active");
        }
      }

      var genderkidsactive = document.querySelector(
        ".wizzy-gender-top-filter .wizzy-gender-top-kids-filter"
      );
      var genderkidsfilteractive = document.querySelector(
        '.wizzy-facet-body.facet-body-genders [data-key="_Kids"]'
      );

      if (genderkidsfilteractive) {
        var genderkidsspan = document.querySelector(
          ".wizzy-gender-top-filter .wizzy-gender-top-kids-filter"
        );
        if (genderkidsspan) {
          genderkidsspan.textContent = "Kids";
        }
        if (genderkidsfilteractive.classList.contains("active")) {
          genderkidsactive.classList.add("active");
        }
      }

      var gendermenspanforclick = document.querySelector(
        ".wizzy-gender-top-filter .wizzy-gender-top-men-filter"
      );

      if (gendermenspanforclick) {
        gendermenspanforclick.addEventListener("click", function () {
          var gendermenfilter = document.querySelector(
            '.wizzy-facet-body.facet-body-genders [data-key="_Men"]'
          );
          if (gendermenfilter) {
            gendermenfilter.click();
          }
        });
      }

      var genderwomenspanforclick = document.querySelector(
        ".wizzy-gender-top-filter .wizzy-gender-top-women-filter"
      );

      if (genderwomenspanforclick) {
        genderwomenspanforclick.addEventListener("click", function () {
          var genderwomenfilter = document.querySelector(
            '.wizzy-facet-body.facet-body-genders [data-key="_Women"]'
          );
          if (genderwomenfilter) {
            genderwomenfilter.click();
          }
        });
      }

      var genderkidsspanforclick = document.querySelector(
        ".wizzy-gender-top-filter .wizzy-gender-top-kids-filter"
      );

      if (genderkidsspanforclick) {
        genderkidsspanforclick.addEventListener("click", function () {
          var genderkidsfilter = document.querySelector(
            '.wizzy-facet-body.facet-body-genders [data-key="_Kids"]'
          );
          if (genderkidsfilter) {
            genderkidsfilter.click();
          }
        });
      }
      /**/

      var query = document.querySelector(
        ".wizzy-summary-head .wizzy-capitalize"
      );
      if (query) {
        var words = query.textContent.split(" ");
        console.log("VIEW_RENDERED->>>", words);
        var capitalizedWords = words.map(function (word) {
          var parts = word.split("-");
          var capitalizedParts = parts.map(function (part) {
            return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
          });
          return capitalizedParts.join("-");
        });
        console.log("VIEW_RENDERED->>>", capitalizedWords);
        query.textContent = capitalizedWords.join(" ");
      }

      $("body").removeClass("wizzy-single-product-result");
      if (payload.data.api == "filter" || payload.data.api == "search") {
        let productList = payload.data.response.payload.result;
        if (productList.length == 1) {
          $("body").addClass("wizzy-single-product-result");
        } else {
          $("body").removeClass("wizzy-single-product-result");
        }
      }

      /*code for swatches - starts here*/

      payload.data.response.payload.result.forEach((product) => {
        // console.log(product.swatchURL);
        fetch(product.swatchURL)
          .then((response) => {
            if (!response.ok) {
              // Swallow the error silently for non-OK responses like 404
              return null;
            }
            return response.text();
          })
          .then((response) => {
            // console.log(
            //   $("#" + product.customSwatchIdentifier),
            //   product.customSwatchIdentifier
            // );
            setTimeout(() => {
              $("#" + product.customSwatchIdentifier).html(response.trim());
            }, 500);
            // console.log(response.trim(), "response"); // parse JSON data from the response
          })
          .catch((error) => {
            console.error(
              "There was a problem with the fetch operation:",
              error
            );
          });
      });

      /*ends here*/
      if(window.wizzyConfig.common.collectionHandle == "online-gift-store-for-newborn-baby" && window.innerWidth > 768) {
        if(sessionStorage.getItem("wizzy-2-products-in-a-row") === "true") {
          const banner = document.querySelector(".wz-promotion-banner.wz-banner-type.grid-2");
          if(banner) banner.style.display = "block";
        }
        else if(sessionStorage.getItem("wizzy-4-products-in-a-row") === "true") {
          const banner = document.querySelector(".wz-promotion-banner.wz-banner-type.grid-4");
          if(banner) banner.style.display = "block";
        }
        else if(sessionStorage.getItem("wizzy-6-products-in-a-row") === "true") {
          const banner = document.querySelector(".wz-promotion-banner.wz-banner-type.grid-6");
          if(banner) banner.style.display = "block";
        }

        const visualFilters = document.querySelector(".wizzy-visual-filters-wrapper");
        if(visualFilters) visualFilters.style.display = "flex";
      }
       else if(window.wizzyConfig.common.collectionHandle == "online-gift-store-for-newborn-baby" && window.innerWidth < 768) {

        const bannerMobile = document.querySelector(".wz-promotion-banner.wz-banner-type.mobile");
        if(bannerMobile) bannerMobile.style.display = "block";

        const visualFilters = document.querySelector(".wizzy-visual-filters-wrapper");
        if(visualFilters) visualFilters.style.display = "flex";
      }
      var filterItems = document.querySelectorAll('.wizzy-facet-list-item');

      if (filterItems.length > 0) {
        filterItems.forEach((filterItem) => {
          filterItem.addEventListener('click', function(){
            realPage = 1;
          });
        })
      }

      var sortItems = document.querySelectorAll('.wizzy-common-select-option');

      if (sortItems.length > 0) {
        sortItems.forEach((soertItem) => {
          soertItem.addEventListener('click', function(){
            realPage = 1;
          });
        })
      }
      if(wizzyConfig.common.collectionHandle === "online-gift-store-for-newborn-baby" && window.innerWidth > 768) {
        moveSelectedFilters();
      }
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (data) {
      console.log("wizzy after products",data)
      /*set swatch url - starts here*/
      data.forEach((product) => {
        product.url = product.url.replace(
          "https://star-delite.myshopify.com",
          "https://global.westside.com"
        );
        product.swatchURL = product.url + "?&view=wizzy-swatchView";
        product.customSwatchIdentifier = "swatch-" + product.id;
        if (product.attributes) {
          product.attributes.forEach((atr) =>{
            if (atr.id === 'product_handle' && atr.values[0].value[0] !== 'weststyleclub') {
              product.showWishListBtn = true;
            }
          })
        }
      });
      /*set swatch url - ends here*/
      let n = data.length;
      for (let i = 0; i < n; i++) {
        /*changes - 27/01/2025 starts here*/
        data[i].attributes?.forEach((atr) => {
          if (
            atr.id === "product_value_tags_apperal_swatch" &&
            atr.values[0].value[0]
          ) {
            data[i].images = data[i].images.filter((_, index) => index !== 1);
          }
        });
        /*changes - 27/01/2025 ends here*/
        data[i].customSwatches = [];
        data[i].displayQuickView = true;
        let totalImages = data[i].images.length;
        if (totalImages >= 3) {
          data[i].slidingImages = [
            { image: data[i].images[0] },
            { image: data[i].images[1] },
            { image: data[i].images[2] },
          ];
        } else {
          data[i].slidingImages = [
            {
              image:
                typeof data[i].images[0] == "undefined"
                  ? data[i].mainImage
                  : data[i].images[0],
            },
            {
              image:
                typeof data[i].images[1] == "undefined"
                  ? data[i].mainImage
                  : data[i].images[1],
            },
            {
              image:
                typeof data[i].images[2] == "undefined"
                  ? data[i].mainImage
                  : data[i].images[2],
            },
          ];
        }

        // Change for internation market - 31-01-2026
        if (data[i].name === "WestStyleClub") {
          data[i].url = "https://global.westside.com/pages/membership";
        }
        let m = data[i]?.attributes?.length;

        for (let j = 0; j < m; j++) {
          if (data[i].attributes[j].id === "product_Multi_Variant_Product") {
            let multiVarientData = data[i].attributes[j].values[0].value[0];
            const items = multiVarientData.split(", ");
            const result = items.map((item) => item.split("|"));

            // result will be of the form -> [0 => ["product handle", "color name"], 1 => [] ... ]
            if (result.length == 0) break;

            result.forEach((indevidualSwatch) => {
              if (indevidualSwatch.length > 1) {
                let temp = "";
                for (let k = indevidualSwatch[0].length - 1; k >= 0; k--) {
                  if (indevidualSwatch[0][k] === "-") {
                    break;
                  }

                  temp = indevidualSwatch[0][k] + temp;
                }

                let numberValue = temp;
                let colorValue = indevidualSwatch[1].replace(/\s/g, "");

                // Change for internation market - 31-01-2026
                let urlOfColor =
                  "https://global.westside.com/cdn/shop/products/" +
                  numberValue +
                  colorValue +
                  "_5.jpg";
                let urlOfProduct =
                  "https://global.westside.com/products/" + indevidualSwatch[0];

                data[i].customSwatches.push({
                  urlOfColor: urlOfColor,
                  urlOfProduct: urlOfProduct,
                });
              }
            });
          } else if (
            data[i].attributes[j].id === "product_value_tags_online_exclusive"
          ) {
            data[i].onlineOnly = true;
          } else if (data[i].attributes[j].id === "product_tags") {
            data[i].newArrival =
              data[i].attributes[j].values[0].value[0].includes("New Flag");
          }
        }
      }

      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
    function (payload) {
      return (
        $("body").on("click", "#init-wizzy-featured-view-button", function () {
          if (typeof window.initFeaturedView !== "undefined") {
            window.initFeaturedView({
              dom: "wizzyFeaturedViewRoot",
              filters: window.location.href.includes(
                window.wizzyConfig.search.configs.general.searchEndpoint
              )
                ? JSON.stringify(
                    window.wizzyConfig.pageStore.searchedResponse.filters
                  )
                : window.wizzyConfig.pageStore.lastExecutedFilters,
              attributeIds: ["product_variant_ids"],
              displayImageInSquare:
                "9:16 Vertical Rectangle" === "1:1 Square" ? true : false,
              displayStoreName: true,
              displayDispalyAddToCartNumber: true,
              storeName: "WESTSIDE",
              currentCartCount: 0,
              displayAddToCart: true,
              displayViewMore: true,
              attributesToShowOnViewMore: ["product_Color"],
            });
          }
        }),
        payload
      );
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (data) {
      if (window.innerWidth > 768) {
        const selectedItem = document.querySelector(
          ".wizzy-common-select-selectedItem"
        );

        // console.log(selectedItem,payload,"view rendered=====>");
        if (
          (selectedItem &&
            selectedItem.innerText.trim().toLowerCase() === "recommended") ||
          selectedItem.innerText.trim().toLowerCase() == ""
        ) {
          selectedItem.innerText = "SORT";
        }

        var container = document.querySelector(
          ".wizzy-common-select-container"
        );
        var drawer = document.querySelector(".wizzy-search-filters-drawer");
        var wrapper = document.querySelector(".wizzy-common-select-wrapper");

        if (container && drawer) {
          var width = window.getComputedStyle(container).width;
          var widthNumber = parseFloat(width);
          console.log(widthNumber, "============>widthNumber");
          var newRight;
          if (wizzyConfig.common.isOnCategoryPage) newRight = widthNumber + 50;
          else newRight = widthNumber + 50;

          drawer.style.right = newRight + "px";
          wrapper.style.width = newRight - 30 + "px";
        } else {
          console.log("One or both elements not found");
        }
      }

      // wizzyCachedFilters Code Starts
      if (window.wizzyConfig.common.isOnCategoryPage === true) {
        wizzyCachedFilters = getCachedFilters();
      }
      // wizzyCachedFilters Code Ends

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (data) {
      return (
        $("body").on("click", "#init-wizzy-featured-view-button", function () {
          // if (typeof window.initFeaturedView !== "undefined") {
          window.initFeaturedView({
            dom: "wizzyFeaturedViewRoot",
            filters: JSON.stringify(
              window.wizzyConfig.pageStore.searchedResponse.filters
            ),
            attributeIds: ["product_variant_ids"],
            displayImageInSquare:
              "9:16 Vertical Rectangle" === "1:1 Square" ? true : false,
            displayStoreName: true,
            displayDispalyAddToCartNumber: true,
            storeName: "WESTSIDE",
            currentCartCount: 0,
            displayAddToCart: true,
            displayViewMore: true,
            attributesToShowOnViewMore: ["product_Color"],
          });
          // }
        }),
        data
      );
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (data) {
      console.log("======>BEFORE_RENDER_RESULTS", data);
      var collectionForGenderFilterAtTop = [
        "denim-view-all",
        "holi-collection",
        "gen-z-fashion-for-women-and-man",
        "man-woman-nuon",
      ];
      let n = data?.response?.payload?.facets?.length;
      if(!n)
        return data;
    
      for (let i = 0; i < n; i++) {
        if (data.response.payload.facets[i].key === "sizes") {
          let m = data.response.payload.facets[i].data.length;
          let newArray = [];
          for (let ii = 0; ii < availableSizeStrings.length; ii++) {
            for (let jj = 0; jj < m; jj++) {
              // console.log(data.response.payload.facets[i].data[jj].key);
              if (
                data.response.payload.facets[i].data[jj].key ===
                availableSizeStrings[ii]
              ) {
                newArray.push(data.response.payload.facets[i].data[jj]);
              }
            }
          }

          data.response.payload.facets[i].data = newArray;

          // break;
        } else if (
          (data.response.payload.facets[i].key ===
            "product_Wizzy_Gender_Product" ||
            data.response.payload.facets[i].key === "genders") &&
          window.wizzyConfig.common.isOnCategoryPage &&
          collectionForGenderFilterAtTop.includes(
            window.wizzyConfig.common.collectionHandle
          )
        ) {
          data.response.payload.facets[i].order = 0;
        } else if (data.response.payload.facets[i].key === "product_value_tags_age_filter") {
           let age = data.response.payload.facets[i].data,
            numbers = [],
            letters = [],
            newArray = new Array(),
            temp = ["Newborns", "New Borns", "Infants", "Junior Kids", "Teens"];
          for (let j = 0; j < temp.length; j++)
            for (let k = 0; k < age.length; k++)
              age[k].key == temp[j] && newArray.push(age[k]);
          data.response.payload.facets[i].data = newArray;
        }
      }

      const lableMapping = {
        Newborn: "0-12 months- New Born",
        Infants: "6 months to 3 years- Infant",
        "Junior Kids": "3-10- Juniors",
        "Teen Kids": "9-14- Teens",
      };

      data.response.payload.facets.forEach((facet) => {
        if (facet.key === "product_value_tags_kid_size") {
          facet.data.forEach((d) => {
            d.label = lableMapping[d.key];
          });
        }
      });

      var tempPage = window.wizzyConfig?.pageStore?.searchedResponse?.filters?.page;

      if (tempPage && realPage > 1) {
        var tempRealPage = realPage - 1;
        data.response.payload.filters.page = tempRealPage;
      }

      var results = data.response?.payload?.result;

      if (results && results.length > 0) {
        var lastProduct = results.at(-1);
        var lastId = lastProduct?.groupId || lastProduct?.id || null;
        if (lastId) lastProductId = parseInt(lastId);
        if (lastProductId && wizzyCollectionProductIds2.length > 0) {
          if (lastProductId === wizzyCollectionProductIds2[wizzyCollectionProductIds2.length - 1]) {
            boostingDone = true;
          }
        }
      }

      return data;
    }
  );

  if (document.documentElement.clientWidth < 768) {
    $("body").on(
      "click",
      "summary.header__icon.header__icon--search",
      function (event) {
        // console.log(event.target, "Hello World!");

        setTimeout(function () {
          let inputBox = document.querySelector(
            ".field__input.header-search__input"
          );
          if (inputBox) {
            // console.log(inputBox, event.target);
            inputBox.click();
            inputBox.focus();
          }
        }, 300);
      }
    );
  }

  $("body").on("change", ".wizzy-range-for-grid", function (event) {
    handleRangeInputValueChange(event.target.value);
  });

  function handleRangeInputValueChange(value) {
    let x = document.querySelector(".wizzy-search-results");
    if (typeof x != "undefined") {
      if (x.classList.contains("wizzy-2-products-in-a-row")) {
        x.classList.remove("wizzy-2-products-in-a-row");
      }

      if (x.classList.contains("wizzy-4-products-in-a-row")) {
        x.classList.remove("wizzy-4-products-in-a-row");
      }

      if (x.classList.contains("wizzy-6-products-in-a-row")) {
        x.classList.remove("wizzy-6-products-in-a-row");
      }

      sessionStorage.setItem("wizzy-2-products-in-a-row", false);
      sessionStorage.setItem("wizzy-4-products-in-a-row", false);
      sessionStorage.setItem("wizzy-6-products-in-a-row", false);
      x.classList.add("wizzy-" + value + "-products-in-a-row");
      sessionStorage.setItem("wizzy-" + value + "-products-in-a-row", true);
    }
    if(window.wizzyConfig.common.collectionHandle == "online-gift-store-for-newborn-baby" && window.innerWidth > 768) {
    if(value == 2) {
      const banner4 = document.querySelector(".wz-promotion-banner.wz-banner-type.grid-4");
      const banner6 = document.querySelector(".wz-promotion-banner.wz-banner-type.grid-6");
      const banner2 = document.querySelector(".wz-promotion-banner.wz-banner-type.grid-2");
      if(banner4 && banner6) {
        banner4.style.display = "none";
        banner6.style.display = "none";
      }
      if(banner2) {
        banner2.style.display = "block";
      }
    }
    else if(value == 4) {
      const banner4 = document.querySelector(".wz-promotion-banner.wz-banner-type.grid-4");
      const banner6 = document.querySelector(".wz-promotion-banner.wz-banner-type.grid-6");
      const banner2 = document.querySelector(".wz-promotion-banner.wz-banner-type.grid-2");
      if(banner2 && banner6) {
        banner2.style.display = "none";
        banner6.style.display = "none";
      }
      if(banner4) {
        banner4.style.display = "block";
      }
    }
    else if(value == 6) {
      const banner4 = document.querySelector(".wz-promotion-banner.wz-banner-type.grid-4");
      const banner6 = document.querySelector(".wz-promotion-banner.wz-banner-type.grid-6");
      const banner2 = document.querySelector(".wz-promotion-banner.wz-banner-type.grid-2");
      if(banner4 && banner2) {
        banner4.style.display = "none";
        banner2.style.display = "none";
      }
      if(banner6) {
        banner6.style.display = "block";
      }
    }
  }
  }

  // For coming back from product page
  function toHandleComingBackFromProductPage() {
    let waitForInputToLoad = setInterval(function () {
      let CBrangeInputForGrid = document.querySelector(".wizzy-range-for-grid");
      if (CBrangeInputForGrid != null && CBrangeInputForGrid != undefined) {
        if (sessionStorage.getItem("wizzy-2-products-in-a-row") === "true") {
          CBrangeInputForGrid.value = 2;
          handleRangeInputValueChange(2);
        } else if (
          sessionStorage.getItem("wizzy-4-products-in-a-row") === "true"
        ) {
          CBrangeInputForGrid.value = 4;
          handleRangeInputValueChange(4);
        } else if (
          sessionStorage.getItem("wizzy-6-products-in-a-row") === "true"
        ) {
          CBrangeInputForGrid.value = 6;
          handleRangeInputValueChange(6);
        }
        clearInterval(waitForInputToLoad);
      }
    }, 1000);

    setTimeout(function () {
      clearInterval(waitForInputToLoad);
    }, 10000);
  }

  toHandleComingBackFromProductPage();

  changeTemplate("wizzy-search-results-product");
  changeTemplate("wizzy-search-wrapper");
  changeTemplate("wizzy-search-empty-results");
  changeTemplate("wizzy-search-summary");
  changeTemplate("wizzy-search-sort");
  changeTemplate("wizzy-common-select");
};

var observer = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutationRecord) {
    let x = mutationRecord.target;
    if (x.classList.contains("wizzy-search-results-rendered")) {
      customFunctionForSwiper();
    }
  });
});

var target = document.querySelector("body");
observer.observe(target, { attributes: true, attributeFilter: ["class"] });

var sectionHeader = document.querySelector(".section-header");

if (sectionHeader !== null && typeof sectionHeader !== "undefined") {
  if (getComputedStyle(sectionHeader).position === "fixed") {
    document.querySelector("body").classList.add("wizzy-header-sticky-margin");
  }
}

function scrollToFirstProduct() {
  setTimeout(function() {
    var firstLi = $('.wizzy-search-results-list li.wizzy-result-product').first();
    if (firstLi.length) {
      var offset = 100; 
      var elementTop = firstLi.offset().top;
      var scrollPosition = elementTop - offset;
      
      window.scrollTo({
        top: scrollPosition,
        behavior: 'smooth'
      });
    }
  }, 100);
}

$("body").on("click", ".wizzy-visual-filters.girl", function(event) {
  const activeBoysFacet = document.querySelector(".wizzy-facet-body.facet-body-product_Wizzy_Gender_Product ul li[data-key=_attributes_product_Wizzy_Gender_Product_Boys].active");
  const activeAccessoriesFacet = document.querySelector(".wizzy-facet-body.facet-body-product_Wizzy_Type_Of_Product_Product ul li[data-key=_attributes_product_Wizzy_Type_Of_Product_Product_Accessories].active");
  const girlFacet = document.querySelector(".wizzy-facet-body.facet-body-product_Wizzy_Gender_Product ul li[data-key=_attributes_product_Wizzy_Gender_Product_Girls]");
  
  if(activeAccessoriesFacet) activeAccessoriesFacet.click();
  if(activeBoysFacet) activeBoysFacet.click();
  if(girlFacet) girlFacet.click();

  realPage = 1;
  
  scrollToFirstProduct();
});

$("body").on("click", ".wizzy-visual-filters.boy", function(event) {
  const activeGirlFacet = document.querySelector(".wizzy-facet-body.facet-body-product_Wizzy_Gender_Product ul li[data-key=_attributes_product_Wizzy_Gender_Product_Girls].active");
  const activeAccessoriesFacet = document.querySelector(".wizzy-facet-body.facet-body-product_Wizzy_Type_Of_Product_Product ul li[data-key=_attributes_product_Wizzy_Type_Of_Product_Product_Accessories].active");
  const boysFacet = document.querySelector(".wizzy-facet-body.facet-body-product_Wizzy_Gender_Product ul li[data-key=_attributes_product_Wizzy_Gender_Product_Boys]");
  
  if(activeAccessoriesFacet) activeAccessoriesFacet.click();
  if(activeGirlFacet) activeGirlFacet.click();
  if(boysFacet) boysFacet.click();

  realPage = 1;
  
  scrollToFirstProduct();
});

$("body").on("click", ".wizzy-visual-filters.accesories", function(event) {
  const activeGirlFacet = document.querySelector(".wizzy-facet-body.facet-body-product_Wizzy_Gender_Product ul li[data-key=_attributes_product_Wizzy_Gender_Product_Girls].active");
  const activeBoysFacet = document.querySelector(".wizzy-facet-body.facet-body-product_Wizzy_Gender_Product ul li[data-key=_attributes_product_Wizzy_Gender_Product_Boys].active");
  
  if(activeBoysFacet) activeBoysFacet.click();
  if(activeGirlFacet) activeGirlFacet.click();
  
  const accesoriesFacet = document.querySelector(".wizzy-facet-body.facet-body-product_Wizzy_Type_Of_Product_Product ul li[data-key=_attributes_product_Wizzy_Type_Of_Product_Product_Accessories]");
  if(accesoriesFacet) accesoriesFacet.click();

  realPage = 1;
  
  scrollToFirstProduct();
});

$("body").on("click", ".wizzy-selected-facet-list-item,.wizzy-common-select-option,.noUi-touch-area", function(event) {
  console.log("Wiz FACET clicked", realPage);
  if (realPage !== 1) {
    realPage = 1;
  }

});

$("body").on("change", ".wizzy-selected-facet-list-item,.wizzy-common-select-option", function(event) {
  // console.log("Wiz FACET clicked", realPage);
  if (realPage !== 1) {
    realPage = 1;
  }

});

$("body").on("click", ".wizzy-search-results-wrapper .wizzy-search-filters-left .wizzy-filters-header .wizzy-filters-clear-all", function(event) {
  // console.log("Wiz reset clicked", realPage);
  if (realPage !== 1) {
    realPage = 1;
  }

});

// wizzyCachedFilters Code Starts
function areStringArraysEqual(a = [], b = []) {
  if (a.length !== b.length) return false;

  const setA = new Set(a);
  for (const val of b) {
    if (!setA.has(val)) return false;
  }
  return true;
}

function arePriceRangesEqual(a = [], b = []) {
  if (a.length !== b.length) return false;

  const normalize = arr =>
    arr
      .map(r => `${r.gte ?? ''}-${r.lte ?? ''}`)
      .sort();

  const na = normalize(a);
  const nb = normalize(b);

  return na.every((v, i) => v === nb[i]);
}

function areAttributesEqual(a = {}, b = {}) {
  const keysA = Object.keys(a);
  const keysB = Object.keys(b);

  if (keysA.length !== keysB.length) return false;

  for (const key of keysA) {
    if (!Array.isArray(b[key])) return false;

    const arrA = a[key];
    const arrB = b[key];

    if (arrA.length !== arrB.length) return false;

    const setA = new Set(arrA);
    for (const val of arrB) {
      if (!setA.has(val)) return false;
    }
  }

  return true;
}

function normalizeRange(range) {
  return JSON.stringify({
    gte: Number(range.gte),
    lte: Number(range.lte)
  });
}

function areRangeArraysEqual(arrA = [], arrB = []) {
  if (arrA.length !== arrB.length) return false;

  const normA = arrA.map(normalizeRange).sort();
  const normB = arrB.map(normalizeRange).sort();

  for (let i = 0; i < normA.length; i++) {
    if (normA[i] !== normB[i]) return false;
  }

  return true;
}

function areFloatAttributesEqual(a = {}, b = {}) {
  const keysA = Object.keys(a);
  const keysB = Object.keys(b);

  if (keysA.length !== keysB.length) return false;

  for (const key of keysA) {
    if (!Array.isArray(b[key])) return false;

    if (!areRangeArraysEqual(a[key], b[key])) return false;
  }

  return true;
}

function hasFilterStateChanged(currentFilters) {
  if (!wizzyCachedFilters) return true;

  if (!areAttributesEqual(
        currentFilters.attributes || {},
        wizzyCachedFilters.attributes
      )) return true;

  if (!areFloatAttributesEqual(
        currentFilters.floatAttributes || {},
        wizzyCachedFilters.floatAttributes
      )) return true;

  if (!areStringArraysEqual(
        currentFilters.brands || [],
        wizzyCachedFilters.brands
      )) return true;

  if (!areStringArraysEqual(
        currentFilters.colors || [],
        wizzyCachedFilters.colors
      )) return true;

  if (!areStringArraysEqual(
        currentFilters.sizes || [],
        wizzyCachedFilters.sizes
      )) return true;

  if (!arePriceRangesEqual(
        currentFilters.sellingPrice || [],
        wizzyCachedFilters.sellingPrice
      )) return true;

  if (!areStringArraysEqual(
        currentFilters.genders || [],
        wizzyCachedFilters.genders
      )) return true;

  return false;
}

function deepClone(obj) {
  if (typeof structuredClone === "function") {
    return structuredClone(obj);
  }
  return JSON.parse(JSON.stringify(obj));
}

function getSessionNumber(key, defaultValue = 0) {
  const val = sessionStorage.getItem(key);
  return val !== null ? Number(val) : defaultValue;
}

function setSessionNumber(key, value) {
  sessionStorage.setItem(key, String(value));
}

function getSessionString(key, defaultValue = null) {
  const val = sessionStorage.getItem(key);
  return val !== null ? val : defaultValue;
}

function setSessionString(key, value) {
  if (value === null || value === undefined) {
    sessionStorage.removeItem(key);
  } else {
    sessionStorage.setItem(key, String(value));
  }
}

function setCachedFilters(filters) {
  sessionStorage.setItem(
    "wizzyCachedFilters",
    JSON.stringify(filters)
  );
}

function getCachedFilters() {
  try {
    return JSON.parse(
      sessionStorage.getItem("wizzyCachedFilters")
    ) || null;
  } catch {
    return null;
  }
}

function getSessionStringArray(key, defaultValue = []) {
  try {
    const val = sessionStorage.getItem(key);
    return val ? JSON.parse(val) : defaultValue;
  } catch {
    return defaultValue;
  }
}

function setSessionStringArray(key, array) {
  try {
    if (!Array.isArray(array)) return;
    sessionStorage.setItem(key, JSON.stringify(array));
  } catch {
    // silently ignore 
  }
}
// wizzyCachedFilters Code Ends

// $("body").on("click", ".wizzy-search-results-wrapper .wizzy-search-filters-left .wizzy-facet-range-slider", function(event) {
//   console.log("Wiz reset clicked", realPage);
//   // if (realPage !== 1) {
//     realPage = 1;
//   // }

// });

// const priceFilterSlider = document.querySelector(".wizzy-facet-range-slider");
//       if(priceFilterSlider) {
//         priceFilterSlider.noUiSlider.on("change", function (values, handle) {
//           console.log("price filter from view rendered");
//           realPage = 1;
//         });
//       }



// function moveSelectedFilters() {
//   if ($('.wizzy-selected-filters').length && $('.wizzy-visual-filters-wrapper').length) {
//     $('.wizzy-selected-filters').insertBefore('.wizzy-visual-filters-wrapper');
//   }
// }

function moveSelectedFilters() {
  const wrapper = $('.wizzy-visual-filters-wrapper').first();
  const selected = $('.wizzy-selected-filters');

  if (wrapper.length && selected.length) {
    selected.insertBefore(wrapper);
  }
}

// document.addEventListener("DOMContentLoaded", function () {

//     const priceFilterSlider = document.querySelector(".wizzy-facet-range-slider");

//     if (priceFilterSlider && priceFilterSlider.noUiSlider) {

//         if (!priceFilterSlider.dataset.changeAttached) {

//             priceFilterSlider.noUiSlider.on("change", function (values, handle) {
//                 realPage = 1;
//             });

//             priceFilterSlider.dataset.changeAttached = "true";
//         }

//     }

// });

function customFunctionForSwiper() {
  // var intervalForSwiper = setInterval(function () {
  //   let x = document.querySelector(".wizzy-result-product-item .swiper");
  //   if (typeof x != "undefined" && x !== null) {
  //     const swiper = new Swiper(".swiper", {
  //       pagination: {
  //         el: ".swiper-pagination",
  //         clickable: true,
  //         type: "bullets",
  //       },
  //       spaceBetween: "30",
  //     });
  //     let y = x.swiper;
  //     clearInterval(intervalForSwiper);
  //   }
  // }, 1000);
  // setTimeout(function () {
  //   clearInterval(intervalForSwiper);
  // }, 30000);
}

customFunctionForSwiper();
